import { c as compute_rest_props, s as subscribe, i as is_promise, n as noop } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, i as each, f as createEventDispatcher, j as add_styles } from "../../../../../../chunks/ssr.js";
import { S as Steps } from "../../../../../../chunks/Steps.js";
import { c as currentProject } from "../../../../../../chunks/projectWizard.js";
import { a as availableAssociates, c as currentCustomer } from "../../../../../../chunks/customer.js";
import "../../../../../../chunks/client.js";
import { T as Typeahead } from "../../../../../../chunks/Typeahead.js";
import { a as availableAddresses } from "../../../../../../chunks/address.js";
import { f as fromEntityStore } from "../../../../../../chunks/DateInput.svelte_svelte_type_style_lang.js";
import { w as writable } from "../../../../../../chunks/index2.js";
import { f as fullCustomer, a as availableProjectLeaders, s as searchCustomers } from "../../../../../../chunks/customer2.js";
import { L as Label } from "../../../../../../chunks/Label.js";
import { I as Input } from "../../../../../../chunks/Input.js";
import { I as IconSolid } from "../../../../../../chunks/IconSolid.js";
import { twMerge } from "tailwind-merge";
import { C as ClipboardListSolid } from "../../../../../../chunks/ClipboardListSolid.js";
import { G as GridSolid } from "../../../../../../chunks/GridSolid.js";
import { U as UserSolid } from "../../../../../../chunks/UserSolid.js";
import { S as Sleep } from "../../../../../../chunks/sleep.js";
import { g as get } from "../../../../../../chunks/api.js";
import { S as Spinner } from "../../../../../../chunks/Spinner.js";
import { S as SortableTable } from "../../../../../../chunks/SortableTable.js";
import { R as RemoveButton } from "../../../../../../chunks/RemoveButton.js";
import { S as Select } from "../../../../../../chunks/Select.js";
import dayjs from "dayjs";
import "../../../../../../chunks/qualification.js";
import "dayjs/plugin/relativeTime.js";
import { H as HomeSolid } from "../../../../../../chunks/HomeSolid.js";
import { F as FileDrop, f as fromBytes } from "../../../../../../chunks/FileDrop.js";
import { s as storeFiles } from "../../../../../../chunks/files.js";
import { B as Button } from "../../../../../../chunks/Button.js";
import { M as Modal } from "../../../../../../chunks/Modal2.js";
import { E as ExclamationCircleOutline } from "../../../../../../chunks/ExclamationCircleOutline.js";
import { T as TrashBinSolid, M as ModalFooter, a as ModalHeader } from "../../../../../../chunks/ModalHeader.js";
import "../../../../../../chunks/convertPdfToImage.js";
import "../../../../../../chunks/modal.js";
import { A as Avatar } from "../../../../../../chunks/Avatar.js";
import { A as Accordion, a as AccordionItem } from "../../../../../../chunks/AccordionItem.js";
import { B as BuildingSolid } from "../../../../../../chunks/BuildingSolid.js";
import { C as CalendarMonthSolid } from "../../../../../../chunks/CalendarMonthSolid.js";
import { E as ExclamationCircleSolid } from "../../../../../../chunks/ExclamationCircleSolid.js";
import { I as InfoCircleSolid } from "../../../../../../chunks/InfoCircleSolid.js";
import { U as UsersGroupSolid } from "../../../../../../chunks/UsersGroupSolid.js";
import { U as UsersSolid } from "../../../../../../chunks/UsersSolid.js";
import "../../../../../../chunks/i18nDate.js";
import { T as Textarea } from "../../../../../../chunks/Textarea.js";
import { n as navigating } from "../../../../../../chunks/stores.js";
import "../../../../../../chunks/project.js";
import { C as CheckCircleOutline } from "../../../../../../chunks/CheckCircleOutline.js";
import { A as AsyncTypeAhead } from "../../../../../../chunks/AsyncTypeAhead.js";
const ClipboardListOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "clipboard list outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-3 5h3m-6 0h.01M12 16h3m-6 0h.01M10 3v4h4V3h-4Z"></path></svg>`} `;
});
const DownloadOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "download outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"></path></svg>`} `;
});
const MapPinAltSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "map pin alt solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z" clip-rule="evenodd"></path></svg>`} `;
});
const PaperClipOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "paper clip outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M7 8v8a5 5 0 1 0 10 0V6.5a3.5 3.5 0 1 0-7 0V15a2 2 0 0 0 4 0V8"></path></svg>`} `;
});
const PenNibSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "pen nib solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M15.514 3.293a1 1 0 0 0-1.415 0L12.151 5.24a.93.93 0 0 1 .056.052l6.5 6.5a.97.97 0 0 1 .052.056L20.707 9.9a1 1 0 0 0 0-1.415l-5.193-5.193ZM7.004 8.27l3.892-1.46 6.293 6.293-1.46 3.893a1 1 0 0 1-.603.591l-9.494 3.355a1 1 0 0 1-.98-.18l6.452-6.453a1 1 0 0 0-1.414-1.414l-6.453 6.452a1 1 0 0 1-.18-.98l3.355-9.494a1 1 0 0 1 .591-.603Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M15.514 3.293a1 1 0 0 0-1.415 0L12.151 5.24a.93.93 0 0 1 .056.052l6.5 6.5a.97.97 0 0 1 .052.056L20.707 9.9a1 1 0 0 0 0-1.415l-5.193-5.193ZM7.004 8.27l3.892-1.46 6.293 6.293-1.46 3.893a1 1 0 0 1-.603.591l-9.494 3.355a1 1 0 0 1-.98-.18l6.452-6.453a1 1 0 0 0-1.414-1.414l-6.453 6.452a1 1 0 0 1-.18-.98l3.355-9.494a1 1 0 0 1 .591-.603Z" clip-rule="evenodd"></path></svg>`} `;
});
const Checkbox = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value: value2 = false } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  return `<div class="flex justify-center"><input type="checkbox" class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"${add_attribute("checked", value2, 1)}></div>`;
});
const NumberInput = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value: value2 } = $$props;
  let { label = null } = $$props;
  let { id = "input-" + (Math.random() + 1).toString(36).substring(2) } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${label ? `${validate_component(Label, "Label").$$render($$result, { for: id }, {}, {
      default: () => {
        return `${escape(label)}`;
      }
    })}` : ``} ${validate_component(Input, "Input").$$render(
      $$result,
      { id, type: "number", value: value2 },
      {
        value: ($$value) => {
          value2 = $$value;
          $$settled = false;
        }
      },
      {}
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const TimeInput = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value: value2 } = $$props;
  let { label = null } = $$props;
  let { id = "input-" + (Math.random() + 1).toString(36).substring(2) } = $$props;
  let localValue;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${label ? `${validate_component(Label, "Label").$$render($$result, { for: id }, {}, {
      default: () => {
        return `${escape(label)}`;
      }
    })}` : ``} ${validate_component(Input, "Input").$$render(
      $$result,
      { id, type: "time", value: localValue },
      {
        value: ($$value) => {
          localValue = $$value;
          $$settled = false;
        }
      },
      {}
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const Select_1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { value: value2 } = $$props;
  let { label = null } = $$props;
  let { options = [] } = $$props;
  let { id = "input-" + (Math.random() + 1).toString(36).substring(7) } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.options === void 0 && $$bindings.options && options !== void 0) $$bindings.options(options);
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${label ? `${validate_component(Label, "Label").$$render($$result, { for: id }, {}, {
      default: () => {
        return `${escape(label)}`;
      }
    })}` : ``} ${validate_component(Select, "Select").$$render(
      $$result,
      { id, value: value2 },
      {
        value: ($$value) => {
          value2 = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${each(options, (option) => {
            return `<option${add_attribute("value", option.value, 0)}>${escape(option.label)}</option>`;
          })}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const AddressDisplay = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { address } = $$props;
  let { showMap = false } = $$props;
  let { withIcon = false } = $$props;
  if ($$props.address === void 0 && $$bindings.address && address !== void 0) $$bindings.address(address);
  if ($$props.showMap === void 0 && $$bindings.showMap && showMap !== void 0) $$bindings.showMap(showMap);
  if ($$props.withIcon === void 0 && $$bindings.withIcon && withIcon !== void 0) $$bindings.withIcon(withIcon);
  return `<div class="w-full"><div class="flex gap-2 items-center mb-6">${withIcon ? `${validate_component(HomeSolid, "HomeSolid").$$render(
    $$result,
    {
      slot: "left",
      class: "w-4 h-4 text-primary-400"
    },
    {},
    {}
  )}` : ``} <div><h3 class="text-neutral-600">${escape(address?.name)} <i class="las la-map-marked cursor-pointer text-lg"></i></h3> <div class="text-sm text-neutral-500">${escape(address.street)} ${escape(address.number)} <br> ${escape(address.zip)} ${escape(address.place)}</div></div></div> ${showMap ? `<iframe title="Map" class="col-span-2" width="100%" height="100%" id="gmap_canvas"${add_attribute("src", `https://maps.google.com/maps?q=${address.street.replace(/\s/, "%20")}%20${address.number}%20${address.place}%20${address.country}&t=&z=15&ie=UTF8&iwloc=&output=embed`, 0)} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>` : `${!withIcon ? `<div class="text-sm text-neutral-500">${escape(address.street)} ${escape(address.number)} <br> ${escape(address.zip)} ${escape(address.place)}</div>` : ``}`}</div>`;
});
const AssociateDisplay = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { associate } = $$props;
  if ($$props.associate === void 0 && $$bindings.associate && associate !== void 0) $$bindings.associate(associate);
  return `${associate ? `<div class="overflow-hidden"><h3 class="truncate">${escape(associate.name)}</h3> <div class="text-sm text-neutral-500 truncate">${escape(associate.email)}</div></div>` : ``}`;
});
const ProjectDocuments = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let { uploadable = false } = $$props;
  let loading = false;
  let documents = [];
  const extract = async (accepted, rejected) => {
    currentProject.set(project);
    loading = true;
    if (rejected.length > 0) {
      alert("Datei nicht erlaubt");
    }
    documents = [...documents, ...await storeFiles(accepted)];
    loading = false;
  };
  let previews = [];
  let deleteModal = false;
  let previewModalDocument = null;
  let documentToBeDeleted;
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  if ($$props.uploadable === void 0 && $$bindings.uploadable && uploadable !== void 0) $$bindings.uploadable(uploadable);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${loading ? `<div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>` : `${documents.length > 0 ? `<ul class="divide-y divide-gray-100 rounded-md border border-gray-200">${each(documents, (document) => {
      return `<li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6"><div class="flex w-0 flex-1 items-center"><svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd"></path></svg> <div class="ml-4 flex min-w-0 flex-1 gap-2"><span class="truncate font-medium">${escape(document.name)}</span> </div></div> <div class="ml-4 flex-shrink-0 flex gap-2 items-center"><button class="font-medium text-primary-600 hover:text-primary-500 cursor-pointer">${document.name.endsWith(".pdf") || document.name.endsWith(".jpg") || document.name.endsWith(".jpeg") || document.name.endsWith(".png") ? `Vorschau` : `Download`}</button> <button>${validate_component(TrashBinSolid, "TrashBinSolid").$$render($$result, { class: "h-4 text-red-600 cursor-pointer" }, {}, {})} </button></div> </li>`;
    })}</ul>` : ``} ${uploadable ? `${validate_component(FileDrop, "FileDrop").$$render($$result, { allowedSize: "4MB", extract }, {}, {})}` : ``}`} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        size: "xs",
        autoclose: true,
        open: deleteModal
      },
      {
        open: ($$value) => {
          deleteModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<div class="text-center">${validate_component(ExclamationCircleOutline, "ExclamationCircleOutline").$$render(
            $$result,
            {
              class: "mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
            },
            {},
            {}
          )} <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Soll die Datei ${escape(documentToBeDeleted.name)}
            wirklich gelöscht werden?</h3> ${validate_component(Button, "Button").$$render($$result, { color: "red", class: "mr-2" }, {}, {
            default: () => {
              return `Ja, ich bin sicher`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { color: "alternative" }, {}, {
            default: () => {
              return `Nein, abbrechen`;
            }
          })}</div>`;
        }
      }
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        open: previewModalDocument !== null,
        size: "xs",
        autoclose: true
      },
      {},
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, {}, {}, {
            right: () => {
              return `<div slot="right">${validate_component(Button, "Button").$$render(
                $$result,
                {
                  id: "download",
                  href: previewModalDocument.location,
                  target: "_blank"
                },
                {},
                {
                  default: () => {
                    return `${validate_component(DownloadOutline, "DownloadOutline").$$render($$result, {}, {}, {})}
                    Download`;
                  }
                }
              )}</div>`;
            },
            left: () => {
              return `<div slot="left"></div>`;
            }
          })} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, {}, {}, {
            default: () => {
              return `${escape(previewModalDocument.name)}`;
            }
          })} `;
        },
        default: () => {
          return `${previews.length > 0 ? `${each(previews, (preview, i) => {
            return `<div class="text-center mb-3">Seite ${escape(i + 1)}</div> <img${add_attribute("src", preview, 0)} alt="${"Seite-" + escape(i + 1, true)}">`;
          })}` : `<img${add_attribute("src", previewModalDocument.location, 0)} alt="">`}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const WorkEntryDisplay = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { workentry } = $$props;
  let { qualifications } = $$props;
  if ($$props.workentry === void 0 && $$bindings.workentry && workentry !== void 0) $$bindings.workentry(workentry);
  if ($$props.qualifications === void 0 && $$bindings.qualifications && qualifications !== void 0) $$bindings.qualifications(qualifications);
  return `${qualifications && workentry && workentry.startsAt ? `<div class="grid grid-cols-7 gap-3"><span>${escape(workentry.amount)}</span> <span class="col-span-4">${escape(qualifications.find((q) => q.id === workentry.qualificationId)?.title)}</span> <span>${escape((workentry.startsAt.value || workentry.startsAt).match(/\d{2}:\d{2}/))}</span> <span>${escape((workentry.endsAt.value || workentry.endsAt).match(/\d{2}:\d{2}/))}</span></div>` : ``}`;
});
const ProjectOverview = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let displayTimeframe;
  let displayRequiredPersonell;
  let { project } = $$props;
  let { mode = "create" } = $$props;
  let associates;
  availableAssociates.subscribe((x) => associates = x);
  let customer;
  currentCustomer.subscribe(async (x) => {
    customer = x;
    if (customer && !customer.address) {
      customer = await fullCustomer(customer.uuid);
    }
  });
  let possibleAddresses = [];
  let qualifications;
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  if ($$props.mode === void 0 && $$bindings.mode && mode !== void 0) $$bindings.mode(mode);
  displayTimeframe = () => {
    const start = project.startsAt.value || project.startsAt;
    const end = project.endsAt.value || project.endsAt;
    return dayjs(start).format("DD.MM.YYYY") + (start === end ? "" : " - " + dayjs(end).format("DD.MM.YYYY"));
  };
  displayRequiredPersonell = () => {
    let count = 0;
    for (let i = 0; i < project.workEntries.length; i++) {
      count += parseInt(project.workEntries[i].amount);
    }
    return count;
  };
  return `${validate_component(Accordion, "Accordion").$$render($$result, { multiple: true }, {}, {
    default: () => {
      return `<div class="p-5 border-l border-r border-t rounded-tl-lg rounded-tr-lg border-b border-gray-200 dark:border-gray-700"><h3 class="text-2xl leading-7 text-neutral-600 border-b pb-5">${escape(mode === "create" ? "Ihre Anfrage" : "Ihr Projekt")} im Überblick</h3> ${customer && customer.address ? `<div class="flex gap-3 mb-7 mt-6 place-items-center">${validate_component(BuildingSolid, "BuildingSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(customer.name)}</div> ${project.name && project.name.length > 0 ? `<div class="flex gap-3 mb-7 place-items-center">${validate_component(GridSolid, "GridSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(project.name)}</div>` : ``} ${fromEntityStore(project, "department") ? `<div class="flex gap-3 mb-7 place-items-center">${validate_component(ClipboardListOutline, "ClipboardListOutline").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(fromEntityStore(project, "department") || "")}</div>` : ``} ${project.name ? `<div class="flex gap-3 place-items-center">${validate_component(CalendarMonthSolid, "CalendarMonthSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(displayTimeframe())}</div>` : ``}` : ``}</div> ${project.responsibleUserId ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3" slot="header">${project.associates && project.associates.length > 0 ? `${validate_component(UsersSolid, "UsersSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} <div class="-mt-1 flex gap-2">${validate_component(Avatar, "Avatar").$$render(
            $$result,
            {
              bgColor: "bg-primary-400",
              size: "sm",
              associate: associates.find((x) => x.userId === project.responsibleUserId)
            },
            {},
            {}
          )} ${each(project.associates, (associate) => {
            return `${validate_component(Avatar, "Avatar").$$render(
              $$result,
              {
                bgColor: "bg-primary-400",
                size: "sm",
                associate: associates.find((x) => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)
              },
              {},
              {}
            )}`;
          })}</div>` : `${validate_component(UserSolid, "UserSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(associates && associates.find((x) => x.userId === project.responsibleUserId)?.name || "Besteller auswählen")}`}</div>`;
        },
        default: () => {
          return `<div class="flex gap-3 place-items-center -ml-1">${associates && project.responsibleUserId ? `${validate_component(Avatar, "Avatar").$$render(
            $$result,
            {
              bgColor: "bg-blue-600",
              size: "sm",
              associate: associates.find((x) => x.userId === project.responsibleUserId)
            },
            {},
            {}
          )} ${validate_component(AssociateDisplay, "AssociateDisplay").$$render(
            $$result,
            {
              associate: associates.find((x) => x.userId === project.responsibleUserId)
            },
            {},
            {}
          )}` : ``}</div> ${project.associates && project.associates.length > 0 && associates ? `<div class="flex gap-3 pt-3 mt-3 border-t place-items-center">${validate_component(UsersSolid, "UsersSolid").$$render($$result, { class: "text-primary-400" }, {}, {})}
                Weitere Ansprechpartner</div> <div class="grid gap-3 mt-3 -ml-1 place-items-center">${each(project.associates, (associate) => {
            return `<div class="flex gap-2">${validate_component(Avatar, "Avatar").$$render(
              $$result,
              {
                bgColor: "bg-blue-600",
                size: "sm",
                associate: associates.find((x) => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)
              },
              {},
              {}
            )} ${validate_component(AssociateDisplay, "AssociateDisplay").$$render(
              $$result,
              {
                associate: associates.find((x) => associate.associateId ? x.id === associate.associateId : x.userId === associate.userId)
              },
              {},
              {}
            )} </div>`;
          })}</div>` : ``}`;
        }
      })}` : ``} ${project.address || project.addressUuid && possibleAddresses.length > 0 ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3 place-items-center" slot="header">${validate_component(MapPinAltSolid, "MapPinAltSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} ${escape(project.address ? project.address.name : project.addressUuid ? possibleAddresses.find((x) => x.uuid === project.addressUuid).name : "Adresse auswählen")}</div>`;
        },
        default: () => {
          return `<div class="flex gap-3 place-items-center">${project.addressUuid ? `${validate_component(AddressDisplay, "AddressDisplay").$$render(
            $$result,
            {
              address: possibleAddresses.find((x) => x.uuid === project.addressUuid)
            },
            {},
            {}
          )}` : `${project.address ? `${validate_component(AddressDisplay, "AddressDisplay").$$render($$result, { address: project.address }, {}, {})}` : `<span data-svelte-h="svelte-8v5pmc">noch unbekannt</span>`}`}</div>`;
        }
      })}` : ``} ${project.workEntries ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3 place-items-center" slot="header">${validate_component(UsersGroupSolid, "UsersGroupSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} <span>Personal: ${escape(displayRequiredPersonell())} Einsatzkräfte</span></div>`;
        },
        default: () => {
          return `${each(project.workEntries, (workentry) => {
            return `${validate_component(WorkEntryDisplay, "WorkEntryDisplay").$$render($$result, { workentry, qualifications }, {}, {})}`;
          })}`;
        }
      })}` : ``} ${project.tags ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3 place-items-center" slot="header">${validate_component(InfoCircleSolid, "InfoCircleSolid").$$render($$result, { class: "text-primary-400" }, {}, {})} <span data-svelte-h="svelte-1dhfko2">Eventinfo</span></div>`;
        },
        default: () => {
          return `<div class="grid grid-cols-2 gap-3"><h3 class="flex gap-3 place-items-center" data-svelte-h="svelte-a7v7t"> <i class="la la-users text-primary-400 text-[30px]"></i>
                    Erwartete Gäste</h3> ${escape(fromEntityStore(project, "guests"))} ${escape(parseInt(fromEntityStore(project, "guests")) === 1 ? "Gast" : "Gäste")} <h3 class="flex gap-3 place-items-center" data-svelte-h="svelte-1y9b4js"><i class="la la-utensils text-primary-400 text-[30px]"></i> 
                    Kategorie</h3> ${escape(project.tags[project.tags.findIndex((x) => x.identifier === "category")]?.name || "unbekannt")} <h3 class="flex gap-3 place-items-center" data-svelte-h="svelte-1aot3pr"><i class="la la-bullhorn text-primary-400 text-[30px]"></i> 
                    Anlaß</h3> ${escape(project.tags[project.tags.findIndex((x) => x.identifier === "occasion")]?.name || "unbekannt")} <h3 class="flex gap-3 place-items-center" data-svelte-h="svelte-alqzma"><i class="la la-user-tie text-primary-400 text-[30px]"></i> 
                    Dresscode</h3> ${escape(project.tags[project.tags.findIndex((x) => x.identifier === "outfit")]?.name || "unbekannt")}</div>`;
        }
      })}` : ``} ${project.notes ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3 place-items-center" slot="header">${validate_component(ExclamationCircleSolid, "ExclamationCircleSolid").$$render($$result, { class: "text-red-400" }, {}, {})} <span data-svelte-h="svelte-1x20l1r">Hinweis</span></div>`;
        },
        default: () => {
          return `<p><!-- HTML_TAG_START -->${project.notes}<!-- HTML_TAG_END --></p>`;
        }
      })}` : ``} ${project.documents ? `${validate_component(AccordionItem, "AccordionItem").$$render($$result, {}, {}, {
        header: () => {
          return `<div class="flex gap-3 place-items-center" slot="header">${validate_component(PaperClipOutline, "PaperClipOutline").$$render($$result, { class: "text-primary-400" }, {}, {})} <span data-svelte-h="svelte-lbmoju">Dokumente</span></div>`;
        },
        default: () => {
          return `${validate_component(ProjectDocuments, "ProjectDocuments").$$render($$result, { project }, {}, {})}`;
        }
      })}` : ``}`;
    }
  })}`;
});
const css$2 = {
  code: ".time-picker.svelte-132npca{font-size:1.1em;display:flex;align-items:center;width:-moz-fit-content;width:fit-content;border:1px solid rgba(108, 120, 147, 0.3);border-radius:3px;margin:auto;font-variant-numeric:tabular-nums;margin-top:6px}span.svelte-132npca{-webkit-user-select:all;-moz-user-select:all;user-select:all;outline:none;position:relative;z-index:1;padding:4px 0px}span.svelte-132npca:not(:focus)::-moz-selection{background-color:transparent}span.svelte-132npca:not(:focus)::selection{background-color:transparent}span.svelte-132npca:first-child{padding-left:6px}span.svelte-132npca:last-child{padding-right:6px}",
  map: `{"version":3,"file":"TimePicker.svelte","sources":["TimePicker.svelte"],"sourcesContent":["<script lang=\\"ts\\">export let browseDate;\\nexport let timePrecision;\\nexport let setTime;\\nlet fields = [];\\nfunction select(node) {\\n  const selection = window.getSelection();\\n  const range = document.createRange();\\n  range.selectNodeContents(node);\\n  selection?.removeAllRanges();\\n  selection?.addRange(range);\\n}\\nfunction keydown(e) {\\n  if (e.key === \\"ArrowUp\\" || e.key === \\"ArrowDown\\") {\\n    const value = get_value(e.currentTarget);\\n    const delta = e.key === \\"ArrowUp\\" ? 1 : -1;\\n    set_value(e.currentTarget, value + delta, true);\\n    e.preventDefault();\\n    select(e.currentTarget);\\n  } else if (e.key === \\"ArrowLeft\\" || e.key === \\"ArrowRight\\" || \\":;-,.\\".includes(e.key)) {\\n    const field_index = fields.indexOf(e.currentTarget);\\n    const delta = e.key === \\"ArrowLeft\\" ? -1 : 1;\\n    const el = fields[field_index + delta];\\n    e.preventDefault();\\n    if (el) {\\n      el.focus();\\n      select(el);\\n    }\\n  }\\n}\\nfunction get_value(node) {\\n  const label = get_field(node).label;\\n  if (label === \\"Hours\\") {\\n    return browseDate.getHours();\\n  } else if (label === \\"Minutes\\") {\\n    return browseDate.getMinutes();\\n  } else if (label === \\"Seconds\\") {\\n    return browseDate.getSeconds();\\n  } else {\\n    return browseDate.getMilliseconds();\\n  }\\n}\\nfunction clamp(value, max, loop_around) {\\n  if (loop_around && value < 0) {\\n    return max;\\n  } else if (loop_around && value > max) {\\n    return 0;\\n  } else {\\n    return Math.max(0, Math.min(max, value));\\n  }\\n}\\nfunction get_field(element) {\\n  const label = element.getAttribute(\\"aria-label\\");\\n  if (label === \\"Hours\\") {\\n    return { label, len: 2, max: 23 };\\n  } else if (label === \\"Minutes\\") {\\n    return { label, len: 2, max: 59 };\\n  } else if (label === \\"Seconds\\") {\\n    return { label, len: 2, max: 59 };\\n  } else if (label === \\"Milliseconds\\") {\\n    return { label, len: 3, max: 999 };\\n  } else {\\n    throw new Error(\\"Invalid label \\" + label);\\n  }\\n}\\n$: setText(browseDate);\\nfunction setText(d) {\\n  const hours = (\\"00\\" + d.getHours()).slice(-2);\\n  const minutes = (\\"00\\" + d.getMinutes()).slice(-2);\\n  const seconds = (\\"00\\" + d.getSeconds()).slice(-2);\\n  const milliseconds = (\\"000\\" + d.getMilliseconds()).slice(-3);\\n  if (fields[0] && fields[0].innerText !== hours) {\\n    fields[0].innerText = hours;\\n  }\\n  if (fields[1] && fields[1].innerText !== minutes) {\\n    fields[1].innerText = minutes;\\n  }\\n  if (fields[2] && fields[2].innerText !== seconds) {\\n    fields[2].innerText = seconds;\\n  }\\n  if (fields[3] && fields[3].innerText !== milliseconds) {\\n    fields[3].innerText = milliseconds;\\n  }\\n}\\nfunction set_value(node, value, loop_around = false) {\\n  const field = get_field(node);\\n  value = clamp(value, field.max, loop_around);\\n  if (field.label === \\"Hours\\") {\\n    browseDate.setHours(value);\\n  } else if (field.label === \\"Minutes\\") {\\n    browseDate.setMinutes(value);\\n  } else if (field.label === \\"Seconds\\") {\\n    browseDate.setSeconds(value);\\n  } else if (field.label === \\"Milliseconds\\") {\\n    browseDate.setMilliseconds(value);\\n  }\\n  browseDate = setTime(browseDate);\\n  setText(browseDate);\\n}\\nfunction parse(text, length) {\\n  return parseInt(text.replace(/[^\\\\d]/g, \\"\\").slice(-length));\\n}\\nfunction input(e_unknown) {\\n  const e = e_unknown;\\n  const field = get_field(e.currentTarget);\\n  let new_value;\\n  if (e.inputType === \\"insertText\\") {\\n    const original_text = \\"000\\" + get_value(e.currentTarget);\\n    new_value = parse(original_text + e.currentTarget.innerText, field.len);\\n    if (new_value > field.max && e.data) {\\n      new_value = parse(e.data, field.len);\\n    }\\n  } else {\\n    new_value = parse(\\"000\\" + e.currentTarget.innerText, field.len);\\n  }\\n  set_value(e.currentTarget, new_value);\\n  select(e.currentTarget);\\n}\\nfunction focus(e) {\\n  select(e.currentTarget);\\n}\\n<\/script>\\n\\n{#if timePrecision}\\n\\t<div\\n\\t\\tclass=\\"time-picker\\"\\n\\t\\trole=\\"none\\"\\n\\t\\ton:mousedown={(e) => {\\n\\t\\t\\tif (e.target instanceof HTMLElement && e.target.tagName === 'SPAN') {\\n\\t\\t\\t\\te.target.focus()\\n\\t\\t\\t\\te.preventDefault() // prevent text dragging\\n\\t\\t\\t}\\n\\t\\t}}\\n\\t>\\n\\t\\t<span\\n\\t\\t\\tbind:this={fields[0]}\\n\\t\\t\\trole=\\"spinbutton\\"\\n\\t\\t\\taria-label=\\"Hours\\"\\n\\t\\t\\ttabindex=\\"0\\"\\n\\t\\t\\tcontenteditable\\n\\t\\t\\tinputmode=\\"numeric\\"\\n\\t\\t\\ton:keydown={keydown}\\n\\t\\t\\ton:input={input}\\n\\t\\t\\ton:focus={focus}>{('00' + browseDate.getHours()).slice(-2)}</span\\n\\t\\t>:\\n\\t\\t<span\\n\\t\\t\\tbind:this={fields[1]}\\n\\t\\t\\trole=\\"spinbutton\\"\\n\\t\\t\\taria-label=\\"Minutes\\"\\n\\t\\t\\ttabindex=\\"0\\"\\n\\t\\t\\tcontenteditable\\n\\t\\t\\tinputmode=\\"numeric\\"\\n\\t\\t\\ton:keydown={keydown}\\n\\t\\t\\ton:input={input}\\n\\t\\t\\ton:focus={focus}>{('00' + browseDate.getMinutes()).slice(-2)}</span\\n\\t\\t>\\n\\t\\t{#if timePrecision !== 'minute'}\\n\\t\\t\\t:<span\\n\\t\\t\\t\\tbind:this={fields[2]}\\n\\t\\t\\t\\trole=\\"spinbutton\\"\\n\\t\\t\\t\\taria-label=\\"Seconds\\"\\n\\t\\t\\t\\ttabindex=\\"0\\"\\n\\t\\t\\t\\tcontenteditable\\n\\t\\t\\t\\tinputmode=\\"numeric\\"\\n\\t\\t\\t\\ton:keydown={keydown}\\n\\t\\t\\t\\ton:input={input}\\n\\t\\t\\t\\ton:focus={focus}>{('00' + browseDate.getSeconds()).slice(-2)}</span\\n\\t\\t\\t>\\n\\t\\t\\t{#if timePrecision !== 'second'}\\n\\t\\t\\t\\t.<span\\n\\t\\t\\t\\t\\tbind:this={fields[3]}\\n\\t\\t\\t\\t\\trole=\\"spinbutton\\"\\n\\t\\t\\t\\t\\taria-label=\\"Milliseconds\\"\\n\\t\\t\\t\\t\\ttabindex=\\"0\\"\\n\\t\\t\\t\\t\\tcontenteditable\\n\\t\\t\\t\\t\\tinputmode=\\"numeric\\"\\n\\t\\t\\t\\t\\ton:keydown={keydown}\\n\\t\\t\\t\\t\\ton:input={input}\\n\\t\\t\\t\\t\\ton:focus={focus}>{('000' + browseDate.getMilliseconds()).slice(-3)}</span\\n\\t\\t\\t\\t>\\n\\t\\t\\t{/if}\\n\\t\\t{/if}\\n\\t</div>\\n{/if}\\n\\n<style>.time-picker {\\n  font-size: 1.1em;\\n  display: flex;\\n  align-items: center;\\n  width: -moz-fit-content;\\n  width: fit-content;\\n  border: 1px solid rgba(108, 120, 147, 0.3);\\n  border-radius: 3px;\\n  margin: auto;\\n  font-variant-numeric: tabular-nums;\\n  margin-top: 6px;\\n}\\n\\nspan {\\n  -webkit-user-select: all;\\n     -moz-user-select: all;\\n          user-select: all;\\n  outline: none;\\n  position: relative;\\n  z-index: 1;\\n  padding: 4px 0px;\\n}\\nspan:not(:focus)::-moz-selection {\\n  background-color: transparent;\\n}\\nspan:not(:focus)::selection {\\n  background-color: transparent;\\n}\\nspan:first-child {\\n  padding-left: 6px;\\n}\\nspan:last-child {\\n  padding-right: 6px;\\n}</style>\\n"],"names":[],"mappings":"AAwLO,2BAAa,CAClB,SAAS,CAAE,KAAK,CAChB,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,KAAK,CAAE,gBAAgB,CACvB,KAAK,CAAE,WAAW,CAClB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAC1C,aAAa,CAAE,GAAG,CAClB,MAAM,CAAE,IAAI,CACZ,oBAAoB,CAAE,YAAY,CAClC,UAAU,CAAE,GACd,CAEA,mBAAK,CACH,mBAAmB,CAAE,GAAG,CACrB,gBAAgB,CAAE,GAAG,CAChB,WAAW,CAAE,GAAG,CACxB,OAAO,CAAE,IAAI,CACb,QAAQ,CAAE,QAAQ,CAClB,OAAO,CAAE,CAAC,CACV,OAAO,CAAE,GAAG,CAAC,GACf,CACA,mBAAI,KAAK,MAAM,CAAC,gBAAiB,CAC/B,gBAAgB,CAAE,WACpB,CACA,mBAAI,KAAK,MAAM,CAAC,WAAY,CAC1B,gBAAgB,CAAE,WACpB,CACA,mBAAI,YAAa,CACf,YAAY,CAAE,GAChB,CACA,mBAAI,WAAY,CACd,aAAa,CAAE,GACjB"}`
};
const TimePicker = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { browseDate } = $$props;
  let { timePrecision } = $$props;
  let { setTime } = $$props;
  let fields = [];
  function setText(d) {
    ("00" + d.getHours()).slice(-2);
    ("00" + d.getMinutes()).slice(-2);
    ("00" + d.getSeconds()).slice(-2);
    ("000" + d.getMilliseconds()).slice(-3);
  }
  if ($$props.browseDate === void 0 && $$bindings.browseDate && browseDate !== void 0) $$bindings.browseDate(browseDate);
  if ($$props.timePrecision === void 0 && $$bindings.timePrecision && timePrecision !== void 0) $$bindings.timePrecision(timePrecision);
  if ($$props.setTime === void 0 && $$bindings.setTime && setTime !== void 0) $$bindings.setTime(setTime);
  $$result.css.add(css$2);
  {
    setText(browseDate);
  }
  return `${timePrecision ? `<div class="time-picker svelte-132npca" role="none"><span role="spinbutton" aria-label="Hours" tabindex="0" contenteditable inputmode="numeric" class="svelte-132npca"${add_attribute("this", fields[0], 0)}>${escape(("00" + browseDate.getHours()).slice(-2))}</span>:
		<span role="spinbutton" aria-label="Minutes" tabindex="0" contenteditable inputmode="numeric" class="svelte-132npca"${add_attribute("this", fields[1], 0)}>${escape(("00" + browseDate.getMinutes()).slice(-2))}</span> ${timePrecision !== "minute" ? `:<span role="spinbutton" aria-label="Seconds" tabindex="0" contenteditable inputmode="numeric" class="svelte-132npca"${add_attribute("this", fields[2], 0)}>${escape(("00" + browseDate.getSeconds()).slice(-2))}</span> ${timePrecision !== "second" ? `.<span role="spinbutton" aria-label="Milliseconds" tabindex="0" contenteditable inputmode="numeric" class="svelte-132npca"${add_attribute("this", fields[3], 0)}>${escape(("000" + browseDate.getMilliseconds()).slice(-3))}</span>` : ``}` : ``}</div>` : ``}`;
});
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function getMonthLength(year, month) {
  const feb = isLeapYear(year) ? 29 : 28;
  const monthLengths = [31, feb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return monthLengths[month];
}
function toText(date, formatTokens) {
  let text = "";
  if (date) {
    for (const token of formatTokens) {
      if (typeof token === "string") {
        text += token;
      } else {
        text += token.toString(date);
      }
    }
  }
  return text;
}
function getMonthDays(year, month) {
  const monthLength = getMonthLength(year, month);
  const days = [];
  for (let i = 0; i < monthLength; i++) {
    days.push({
      year,
      month,
      number: i + 1
    });
  }
  return days;
}
function getCalendarDays(value2, weekStartsOn) {
  const year = value2.getFullYear();
  const month = value2.getMonth();
  const firstWeekday = new Date(year, month, 1).getDay();
  let days = [];
  const daysBefore = (firstWeekday - weekStartsOn + 7) % 7;
  if (daysBefore > 0) {
    let lastMonth = month - 1;
    let lastMonthYear = year;
    if (lastMonth === -1) {
      lastMonth = 11;
      lastMonthYear = year - 1;
    }
    days = getMonthDays(lastMonthYear, lastMonth).slice(-daysBefore);
  }
  days = days.concat(getMonthDays(year, month));
  let nextMonth = month + 1;
  let nextMonthYear = year;
  if (nextMonth === 12) {
    nextMonth = 0;
    nextMonthYear = year + 1;
  }
  const daysAfter = 42 - days.length;
  days = days.concat(getMonthDays(nextMonthYear, nextMonth).slice(0, daysAfter));
  return days;
}
function getLocaleDefaults() {
  return {
    weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    weekStartsOn: 1
  };
}
function getInnerLocale(locale) {
  const innerLocale = getLocaleDefaults();
  if (typeof locale.weekStartsOn === "number") {
    innerLocale.weekStartsOn = locale.weekStartsOn;
  }
  if (locale.months)
    innerLocale.months = locale.months;
  if (locale.shortMonths)
    innerLocale.shortMonths = locale.shortMonths;
  if (locale.weekdays)
    innerLocale.weekdays = locale.weekdays;
  return innerLocale;
}
const css$1 = {
  code: ".date-time-picker.svelte-go79cf.svelte-go79cf{display:inline-block;color:var(--date-picker-foreground, #000000);background:var(--date-picker-background, #ffffff);-moz-user-select:none;user-select:none;-webkit-user-select:none;padding:0.5rem;cursor:default;font-size:0.75rem;border:1px solid rgba(103, 113, 137, 0.3);border-radius:3px;box-shadow:0px 2px 6px rgba(0, 0, 0, 0.08), 0px 2px 6px rgba(0, 0, 0, 0.11);outline:none;transition:all 80ms cubic-bezier(0.4, 0, 0.2, 1)}.date-time-picker.svelte-go79cf.svelte-go79cf:focus{border-color:var(--date-picker-highlight-border, #0269f7);box-shadow:0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4))}.tab-container.svelte-go79cf.svelte-go79cf{outline:none}.top.svelte-go79cf.svelte-go79cf{display:flex;justify-content:center;align-items:center;padding-bottom:0.5rem}.dropdown.svelte-go79cf.svelte-go79cf{margin-left:0.25rem;margin-right:0.25rem;position:relative;display:flex}.dropdown.svelte-go79cf svg.svelte-go79cf{position:absolute;right:0px;top:0px;height:100%;width:8px;padding:0rem 0.5rem;pointer-events:none;box-sizing:content-box}.month.svelte-go79cf.svelte-go79cf{flex-grow:1}.year.svelte-go79cf.svelte-go79cf{flex-grow:1}svg.svelte-go79cf.svelte-go79cf{display:block;fill:var(--date-picker-foreground, #000000);opacity:0.75;outline:none}.page-button.svelte-go79cf.svelte-go79cf{background-color:transparent;width:1.5rem;height:1.5rem;flex-shrink:0;border-radius:5px;box-sizing:border-box;border:1px solid transparent;display:flex;align-items:center;justify-content:center}.page-button.svelte-go79cf.svelte-go79cf:hover{background-color:rgba(128, 128, 128, 0.08);border:1px solid rgba(128, 128, 128, 0.08)}.page-button.svelte-go79cf svg.svelte-go79cf{width:0.68rem;height:0.68rem}select.dummy-select.svelte-go79cf.svelte-go79cf{position:absolute;width:100%;pointer-events:none;outline:none;color:var(--date-picker-foreground, #000000);background-color:var(--date-picker-background, #ffffff);border-radius:3px}select.svelte-go79cf:focus+select.dummy-select.svelte-go79cf{border-color:var(--date-picker-highlight-border, #0269f7);box-shadow:0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4))}select.svelte-go79cf.svelte-go79cf:not(.dummy-select){opacity:0}select.svelte-go79cf.svelte-go79cf{font-size:inherit;font-family:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;flex-grow:1;padding:0rem 0.35rem;height:1.5rem;padding-right:1.3rem;margin:0px;border:1px solid rgba(108, 120, 147, 0.3);outline:none;transition:all 80ms cubic-bezier(0.4, 0, 0.2, 1);background-image:none}.header.svelte-go79cf.svelte-go79cf{display:flex;font-weight:600;padding-bottom:2px}.header-cell.svelte-go79cf.svelte-go79cf{width:1.875rem;text-align:center;flex-grow:1}.week.svelte-go79cf.svelte-go79cf{display:flex}.cell.svelte-go79cf.svelte-go79cf{display:flex;align-items:center;justify-content:center;width:2rem;height:1.94rem;flex-grow:1;border-radius:5px;box-sizing:border-box;border:2px solid transparent}.cell.svelte-go79cf.svelte-go79cf:hover{border:1px solid rgba(128, 128, 128, 0.08)}.cell.today.svelte-go79cf.svelte-go79cf{font-weight:600;border:2px solid var(--date-picker-today-border, rgba(128, 128, 128, 0.3))}.cell.svelte-go79cf.svelte-go79cf:hover{background-color:rgba(128, 128, 128, 0.08)}.cell.disabled.svelte-go79cf.svelte-go79cf{visibility:hidden}.cell.disabled.svelte-go79cf.svelte-go79cf:hover{border:none;background-color:transparent}.cell.other-month.svelte-go79cf span.svelte-go79cf{opacity:0.4}.cell.selected.svelte-go79cf.svelte-go79cf{color:var(--date-picker-selected-color, inherit);background:var(--date-picker-selected-background, rgba(2, 105, 247, 0.2));border:2px solid var(--date-picker-highlight-border, #0269f7)}",
  map: '{"version":3,"file":"DatePicker.svelte","sources":["DatePicker.svelte"],"sourcesContent":["<script lang=\\"ts\\">import TimePicker from \\"./TimePicker.svelte\\";\\nimport { getMonthLength, getCalendarDays } from \\"./date-utils.js\\";\\nimport { getInnerLocale } from \\"./locale.js\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nconst dispatch = createEventDispatcher();\\nfunction cloneDate(d) {\\n  return new Date(d.getTime());\\n}\\nexport let value = null;\\nfunction setValue(d) {\\n  if (d.getTime() !== value?.getTime()) {\\n    browseDate = clamp(d, min, max);\\n    value = cloneDate(browseDate);\\n  }\\n}\\nfunction setValueDate(d) {\\n  if (d.getTime() !== value?.getTime()) {\\n    browseDate = clampDate(d, min, max);\\n    value = cloneDate(browseDate);\\n  }\\n}\\nfunction browse(d) {\\n  browseDate = clampDate(d, min, max);\\n  if (!browseWithoutSelecting && value) {\\n    setValue(browseDate);\\n  }\\n}\\nfunction setTime(d) {\\n  browseDate = clamp(d, min, max);\\n  if (value) {\\n    setValue(browseDate);\\n  }\\n  return browseDate;\\n}\\nconst todayDate = /* @__PURE__ */ new Date();\\nconst defaultDate = /* @__PURE__ */ new Date();\\nexport let timePrecision = null;\\nexport let min = new Date(defaultDate.getFullYear() - 20, 0, 1);\\nexport let max = new Date(defaultDate.getFullYear(), 11, 31, 23, 59, 59, 999);\\n$: if (value && value > max) {\\n  setValue(max);\\n} else if (value && value < min) {\\n  setValue(min);\\n}\\nfunction clamp(d, min2, max2) {\\n  if (d > max2) {\\n    return cloneDate(max2);\\n  } else if (d < min2) {\\n    return cloneDate(min2);\\n  } else {\\n    return cloneDate(d);\\n  }\\n}\\nfunction clampDate(d, min2, max2) {\\n  const limit = clamp(d, min2, max2);\\n  if (limit.getTime() !== d.getTime()) {\\n    d = new Date(limit.getFullYear(), limit.getMonth(), limit.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());\\n    d = clamp(d, min2, max2);\\n  }\\n  return d;\\n}\\nlet browseDate = value ? cloneDate(value) : cloneDate(clampDate(defaultDate, min, max));\\n$: setBrowseDate(value);\\nfunction setBrowseDate(value2) {\\n  if (browseDate.getTime() !== value2?.getTime()) {\\n    browseDate = value2 ? cloneDate(value2) : browseDate;\\n  }\\n}\\nlet years = getYears(min, max);\\n$: years = getYears(min, max);\\nfunction getYears(min2, max2) {\\n  let years2 = [];\\n  for (let i = min2.getFullYear(); i <= max2.getFullYear(); i++) {\\n    years2.push(i);\\n  }\\n  return years2;\\n}\\nexport let locale = {};\\n$: iLocale = getInnerLocale(locale);\\nexport let browseWithoutSelecting = false;\\n$: browseYear = browseDate.getFullYear();\\nfunction setYear(newYear) {\\n  browseDate.setFullYear(newYear);\\n  browse(browseDate);\\n}\\n$: browseMonth = browseDate.getMonth();\\nfunction setMonth(newMonth) {\\n  let newYear = browseDate.getFullYear();\\n  if (newMonth === 12) {\\n    newMonth = 0;\\n    newYear++;\\n  } else if (newMonth === -1) {\\n    newMonth = 11;\\n    newYear--;\\n  }\\n  const maxDate = getMonthLength(newYear, newMonth);\\n  const newDate = Math.min(browseDate.getDate(), maxDate);\\n  browse(new Date(newYear, newMonth, newDate, browseDate.getHours(), browseDate.getMinutes(), browseDate.getSeconds(), browseDate.getMilliseconds()));\\n}\\n$: calendarDays = getCalendarDays(browseDate, iLocale.weekStartsOn);\\nfunction selectDay(calendarDay) {\\n  if (dayIsInRange(calendarDay, min, max)) {\\n    browseDate.setFullYear(0);\\n    browseDate.setMonth(0);\\n    browseDate.setDate(1);\\n    browseDate.setFullYear(calendarDay.year);\\n    browseDate.setMonth(calendarDay.month);\\n    browseDate.setDate(calendarDay.number);\\n    setValueDate(browseDate);\\n    dispatch(\\"select\\", cloneDate(browseDate));\\n  }\\n}\\nfunction dayIsInRange(calendarDay, min2, max2) {\\n  const date = new Date(calendarDay.year, calendarDay.month, calendarDay.number);\\n  const minDate = new Date(min2.getFullYear(), min2.getMonth(), min2.getDate());\\n  const maxDate = new Date(max2.getFullYear(), max2.getMonth(), max2.getDate());\\n  return date >= minDate && date <= maxDate;\\n}\\nfunction shiftKeydown(e) {\\n  if (e.shiftKey && e.key === \\"ArrowUp\\") {\\n    setYear(browseDate.getFullYear() - 1);\\n  } else if (e.shiftKey && e.key === \\"ArrowDown\\") {\\n    setYear(browseDate.getFullYear() + 1);\\n  } else if (e.shiftKey && e.key === \\"ArrowLeft\\") {\\n    setMonth(browseDate.getMonth() - 1);\\n  } else if (e.shiftKey && e.key === \\"ArrowRight\\") {\\n    setMonth(browseDate.getMonth() + 1);\\n  } else {\\n    return false;\\n  }\\n  e.preventDefault();\\n  return true;\\n}\\nfunction yearKeydown(e) {\\n  let shift = e.shiftKey || e.altKey;\\n  if (shift) {\\n    shiftKeydown(e);\\n    return;\\n  } else if (e.key === \\"ArrowUp\\") {\\n    setYear(browseDate.getFullYear() - 1);\\n  } else if (e.key === \\"ArrowDown\\") {\\n    setYear(browseDate.getFullYear() + 1);\\n  } else if (e.key === \\"ArrowLeft\\") {\\n    setMonth(browseDate.getMonth() - 1);\\n  } else if (e.key === \\"ArrowRight\\") {\\n    setMonth(browseDate.getMonth() + 1);\\n  } else {\\n    shiftKeydown(e);\\n    return;\\n  }\\n  e.preventDefault();\\n}\\nfunction monthKeydown(e) {\\n  let shift = e.shiftKey || e.altKey;\\n  if (shift) {\\n    shiftKeydown(e);\\n    return;\\n  } else if (e.key === \\"ArrowUp\\" || e.key === \\"ArrowLeft\\") {\\n    setMonth(browseDate.getMonth() - 1);\\n  } else if (e.key === \\"ArrowDown\\" || e.key === \\"ArrowRight\\") {\\n    setMonth(browseDate.getMonth() + 1);\\n  } else {\\n    shiftKeydown(e);\\n    return;\\n  }\\n  e.preventDefault();\\n}\\nfunction keydown(e) {\\n  let shift = e.shiftKey || e.altKey;\\n  if (e.target?.tagName === \\"SELECT\\" || e.target?.tagName === \\"SPAN\\") {\\n    return;\\n  }\\n  if (shift) {\\n    shiftKeydown(e);\\n    return;\\n  } else if (e.key === \\"ArrowUp\\") {\\n    browseDate.setDate(browseDate.getDate() - 7);\\n    setValueDate(browseDate);\\n  } else if (e.key === \\"ArrowDown\\") {\\n    browseDate.setDate(browseDate.getDate() + 7);\\n    setValueDate(browseDate);\\n  } else if (e.key === \\"ArrowLeft\\") {\\n    browseDate.setDate(browseDate.getDate() - 1);\\n    setValueDate(browseDate);\\n  } else if (e.key === \\"ArrowRight\\") {\\n    browseDate.setDate(browseDate.getDate() + 1);\\n    setValueDate(browseDate);\\n  } else if (e.key === \\"Enter\\") {\\n    setValue(browseDate);\\n    dispatch(\\"select\\", cloneDate(browseDate));\\n  } else {\\n    return;\\n  }\\n  e.preventDefault();\\n}\\n<\/script>\\n\\n<!-- svelte-ignore a11y-no-noninteractive-tabindex -->\\n<!-- svelte-ignore a11y-no-static-element-interactions -->\\n<div class=\\"date-time-picker\\" on:focusout tabindex=\\"0\\" on:keydown={keydown}>\\n\\t<div class=\\"tab-container\\" tabindex=\\"-1\\">\\n\\t\\t<div class=\\"top\\">\\n\\t\\t\\t<button\\n\\t\\t\\t\\ttype=\\"button\\"\\n\\t\\t\\t\\taria-label=\\"Previous month\\"\\n\\t\\t\\t\\tclass=\\"page-button\\"\\n\\t\\t\\t\\ttabindex=\\"-1\\"\\n\\t\\t\\t\\ton:click={() => setMonth(browseDate.getMonth() - 1)}\\n\\t\\t\\t>\\n\\t\\t\\t\\t<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\"\\n\\t\\t\\t\\t\\t><path\\n\\t\\t\\t\\t\\t\\td=\\"M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z\\"\\n\\t\\t\\t\\t\\t\\ttransform=\\"rotate(180, 12, 12)\\"\\n\\t\\t\\t\\t\\t/></svg\\n\\t\\t\\t\\t>\\n\\t\\t\\t</button>\\n\\t\\t\\t<div class=\\"dropdown month\\">\\n\\t\\t\\t\\t<select\\n\\t\\t\\t\\t\\tvalue={browseMonth}\\n\\t\\t\\t\\t\\ton:keydown={monthKeydown}\\n\\t\\t\\t\\t\\ton:input={(e) => setMonth(parseInt(e.currentTarget.value))}\\n\\t\\t\\t\\t>\\n\\t\\t\\t\\t\\t{#each iLocale.months as monthName, i}\\n\\t\\t\\t\\t\\t\\t<option\\n\\t\\t\\t\\t\\t\\t\\tdisabled={new Date(browseYear, i, getMonthLength(browseYear, i), 23, 59, 59, 999) <\\n\\t\\t\\t\\t\\t\\t\\t\\tmin || new Date(browseYear, i) > max}\\n\\t\\t\\t\\t\\t\\t\\tvalue={i}>{monthName}</option\\n\\t\\t\\t\\t\\t\\t>\\n\\t\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t</select>\\n\\t\\t\\t\\t<!--\\n\\t\\t\\t\\t\\tHere we have use `select.dummy-select` for showing just the <select> button. This\\n\\t\\t\\t\\t\\tis to style the <select> button without affecting the menu popup\\n\\t\\t\\t\\t\\t- `option { color: initial }` causes invisible menu in dark mode on Firefox\\n\\t\\t\\t\\t\\t- `option { color: initial; background-color: initial }` causes invisible menu in Chrome\\n\\t\\t\\t\\t\\t- `select { background-color: $bg; color: $text }` causes white scrollbar in dark mode on Firefox\\n\\t\\t\\t\\t-->\\n\\t\\t\\t\\t<select class=\\"dummy-select\\" tabindex=\\"-1\\">\\n\\t\\t\\t\\t\\t{#each iLocale.months as monthName, i}\\n\\t\\t\\t\\t\\t\\t<option value={i} selected={i === browseMonth}>{monthName}</option>\\n\\t\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t</select>\\n\\t\\t\\t\\t<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\"\\n\\t\\t\\t\\t\\t><path d=\\"M6 0l12 12-12 12z\\" transform=\\"rotate(90, 12, 12)\\" /></svg\\n\\t\\t\\t\\t>\\n\\t\\t\\t</div>\\n\\t\\t\\t<div class=\\"dropdown year\\">\\n\\t\\t\\t\\t<select\\n\\t\\t\\t\\t\\tvalue={browseYear}\\n\\t\\t\\t\\t\\ton:input={(e) => setYear(parseInt(e.currentTarget.value))}\\n\\t\\t\\t\\t\\ton:keydown={yearKeydown}\\n\\t\\t\\t\\t>\\n\\t\\t\\t\\t\\t{#each years as v}\\n\\t\\t\\t\\t\\t\\t<option value={v}>{v}</option>\\n\\t\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t</select>\\n\\t\\t\\t\\t<!-- style <select> button without affecting menu popup -->\\n\\t\\t\\t\\t<select class=\\"dummy-select\\" tabindex=\\"-1\\">\\n\\t\\t\\t\\t\\t{#each years as v}\\n\\t\\t\\t\\t\\t\\t<option value={v} selected={v === browseDate.getFullYear()}>{v}</option>\\n\\t\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t</select>\\n\\t\\t\\t\\t<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\"\\n\\t\\t\\t\\t\\t><path d=\\"M6 0l12 12-12 12z\\" transform=\\"rotate(90, 12, 12)\\" /></svg\\n\\t\\t\\t\\t>\\n\\t\\t\\t</div>\\n\\t\\t\\t<button\\n\\t\\t\\t\\ttype=\\"button\\"\\n\\t\\t\\t\\taria-label=\\"Next month\\"\\n\\t\\t\\t\\tclass=\\"page-button\\"\\n\\t\\t\\t\\ttabindex=\\"-1\\"\\n\\t\\t\\t\\ton:click={() => setMonth(browseDate.getMonth() + 1)}\\n\\t\\t\\t>\\n\\t\\t\\t\\t<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\"\\n\\t\\t\\t\\t\\t><path d=\\"M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z\\" /></svg\\n\\t\\t\\t\\t>\\n\\t\\t\\t</button>\\n\\t\\t</div>\\n\\t\\t<div class=\\"header\\">\\n\\t\\t\\t<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->\\n\\t\\t\\t{#each Array(7) as _, i}\\n\\t\\t\\t\\t{#if i + iLocale.weekStartsOn < 7}\\n\\t\\t\\t\\t\\t<div class=\\"header-cell\\">{iLocale.weekdays[iLocale.weekStartsOn + i]}</div>\\n\\t\\t\\t\\t{:else}\\n\\t\\t\\t\\t\\t<div class=\\"header-cell\\">{iLocale.weekdays[iLocale.weekStartsOn + i - 7]}</div>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t{/each}\\n\\t\\t</div>\\n\\t\\t<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->\\n\\t\\t{#each Array(6) as _, weekIndex}\\n\\t\\t\\t<div class=\\"week\\">\\n\\t\\t\\t\\t{#each calendarDays.slice(weekIndex * 7, weekIndex * 7 + 7) as calendarDay}\\n\\t\\t\\t\\t\\t<!-- svelte-ignore a11y-click-events-have-key-events -->\\n\\t\\t\\t\\t\\t<div\\n\\t\\t\\t\\t\\t\\tclass=\\"cell\\"\\n\\t\\t\\t\\t\\t\\ton:click={() => selectDay(calendarDay)}\\n\\t\\t\\t\\t\\t\\tclass:disabled={!dayIsInRange(calendarDay, min, max)}\\n\\t\\t\\t\\t\\t\\tclass:selected={value &&\\n\\t\\t\\t\\t\\t\\t\\tcalendarDay.year === value.getFullYear() &&\\n\\t\\t\\t\\t\\t\\t\\tcalendarDay.month === value.getMonth() &&\\n\\t\\t\\t\\t\\t\\t\\tcalendarDay.number === value.getDate()}\\n\\t\\t\\t\\t\\t\\tclass:today={calendarDay.year === todayDate.getFullYear() &&\\n\\t\\t\\t\\t\\t\\t\\tcalendarDay.month === todayDate.getMonth() &&\\n\\t\\t\\t\\t\\t\\t\\tcalendarDay.number === todayDate.getDate()}\\n\\t\\t\\t\\t\\t\\tclass:other-month={calendarDay.month !== browseMonth}\\n\\t\\t\\t\\t\\t>\\n\\t\\t\\t\\t\\t\\t<span>{calendarDay.number}</span>\\n\\t\\t\\t\\t\\t</div>\\n\\t\\t\\t\\t{/each}\\n\\t\\t\\t</div>\\n\\t\\t{/each}\\n\\n\\t\\t<TimePicker {timePrecision} bind:browseDate {setTime} />\\n\\n\\t\\t<slot />\\n\\t</div>\\n</div>\\n\\n<style>.date-time-picker {\\n  display: inline-block;\\n  color: var(--date-picker-foreground, #000000);\\n  background: var(--date-picker-background, #ffffff);\\n  -moz-user-select: none;\\n       user-select: none;\\n  -webkit-user-select: none;\\n  padding: 0.5rem;\\n  cursor: default;\\n  font-size: 0.75rem;\\n  border: 1px solid rgba(103, 113, 137, 0.3);\\n  border-radius: 3px;\\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08), 0px 2px 6px rgba(0, 0, 0, 0.11);\\n  outline: none;\\n  transition: all 80ms cubic-bezier(0.4, 0, 0.2, 1);\\n}\\n.date-time-picker:focus {\\n  border-color: var(--date-picker-highlight-border, #0269f7);\\n  box-shadow: 0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4));\\n}\\n\\n.tab-container {\\n  outline: none;\\n}\\n\\n.top {\\n  display: flex;\\n  justify-content: center;\\n  align-items: center;\\n  padding-bottom: 0.5rem;\\n}\\n\\n.dropdown {\\n  margin-left: 0.25rem;\\n  margin-right: 0.25rem;\\n  position: relative;\\n  display: flex;\\n}\\n.dropdown svg {\\n  position: absolute;\\n  right: 0px;\\n  top: 0px;\\n  height: 100%;\\n  width: 8px;\\n  padding: 0rem 0.5rem;\\n  pointer-events: none;\\n  box-sizing: content-box;\\n}\\n\\n.month {\\n  flex-grow: 1;\\n}\\n\\n.year {\\n  flex-grow: 1;\\n}\\n\\nsvg {\\n  display: block;\\n  fill: var(--date-picker-foreground, #000000);\\n  opacity: 0.75;\\n  outline: none;\\n}\\n\\n.page-button {\\n  background-color: transparent;\\n  width: 1.5rem;\\n  height: 1.5rem;\\n  flex-shrink: 0;\\n  border-radius: 5px;\\n  box-sizing: border-box;\\n  border: 1px solid transparent;\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n}\\n.page-button:hover {\\n  background-color: rgba(128, 128, 128, 0.08);\\n  border: 1px solid rgba(128, 128, 128, 0.08);\\n}\\n.page-button svg {\\n  width: 0.68rem;\\n  height: 0.68rem;\\n}\\n\\nselect.dummy-select {\\n  position: absolute;\\n  width: 100%;\\n  pointer-events: none;\\n  outline: none;\\n  color: var(--date-picker-foreground, #000000);\\n  background-color: var(--date-picker-background, #ffffff);\\n  border-radius: 3px;\\n}\\n\\nselect:focus + select.dummy-select {\\n  border-color: var(--date-picker-highlight-border, #0269f7);\\n  box-shadow: 0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4));\\n}\\n\\nselect:not(.dummy-select) {\\n  opacity: 0;\\n}\\n\\nselect {\\n  font-size: inherit;\\n  font-family: inherit;\\n  -webkit-appearance: none;\\n  -moz-appearance: none;\\n  appearance: none;\\n  flex-grow: 1;\\n  padding: 0rem 0.35rem;\\n  height: 1.5rem;\\n  padding-right: 1.3rem;\\n  margin: 0px;\\n  border: 1px solid rgba(108, 120, 147, 0.3);\\n  outline: none;\\n  transition: all 80ms cubic-bezier(0.4, 0, 0.2, 1);\\n  background-image: none;\\n}\\n\\n.header {\\n  display: flex;\\n  font-weight: 600;\\n  padding-bottom: 2px;\\n}\\n\\n.header-cell {\\n  width: 1.875rem;\\n  text-align: center;\\n  flex-grow: 1;\\n}\\n\\n.week {\\n  display: flex;\\n}\\n\\n.cell {\\n  display: flex;\\n  align-items: center;\\n  justify-content: center;\\n  width: 2rem;\\n  height: 1.94rem;\\n  flex-grow: 1;\\n  border-radius: 5px;\\n  box-sizing: border-box;\\n  border: 2px solid transparent;\\n}\\n.cell:hover {\\n  border: 1px solid rgba(128, 128, 128, 0.08);\\n}\\n.cell.today {\\n  font-weight: 600;\\n  border: 2px solid var(--date-picker-today-border, rgba(128, 128, 128, 0.3));\\n}\\n.cell:hover {\\n  background-color: rgba(128, 128, 128, 0.08);\\n}\\n.cell.disabled {\\n  visibility: hidden;\\n}\\n.cell.disabled:hover {\\n  border: none;\\n  background-color: transparent;\\n}\\n.cell.other-month span {\\n  opacity: 0.4;\\n}\\n.cell.selected {\\n  color: var(--date-picker-selected-color, inherit);\\n  background: var(--date-picker-selected-background, rgba(2, 105, 247, 0.2));\\n  border: 2px solid var(--date-picker-highlight-border, #0269f7);\\n}</style>\\n"],"names":[],"mappings":"AA8TO,6CAAkB,CACvB,OAAO,CAAE,YAAY,CACrB,KAAK,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAC7C,UAAU,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAClD,gBAAgB,CAAE,IAAI,CACjB,WAAW,CAAE,IAAI,CACtB,mBAAmB,CAAE,IAAI,CACzB,OAAO,CAAE,MAAM,CACf,MAAM,CAAE,OAAO,CACf,SAAS,CAAE,OAAO,CAClB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAC1C,aAAa,CAAE,GAAG,CAClB,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAC5E,OAAO,CAAE,IAAI,CACb,UAAU,CAAE,GAAG,CAAC,IAAI,CAAC,aAAa,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,CAClD,CACA,6CAAiB,MAAO,CACtB,YAAY,CAAE,IAAI,8BAA8B,CAAC,QAAQ,CAAC,CAC1D,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,IAAI,8BAA8B,CAAC,uBAAuB,CACxF,CAEA,0CAAe,CACb,OAAO,CAAE,IACX,CAEA,gCAAK,CACH,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,cAAc,CAAE,MAClB,CAEA,qCAAU,CACR,WAAW,CAAE,OAAO,CACpB,YAAY,CAAE,OAAO,CACrB,QAAQ,CAAE,QAAQ,CAClB,OAAO,CAAE,IACX,CACA,uBAAS,CAAC,iBAAI,CACZ,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,GAAG,CACV,GAAG,CAAE,GAAG,CACR,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,GAAG,CACV,OAAO,CAAE,IAAI,CAAC,MAAM,CACpB,cAAc,CAAE,IAAI,CACpB,UAAU,CAAE,WACd,CAEA,kCAAO,CACL,SAAS,CAAE,CACb,CAEA,iCAAM,CACJ,SAAS,CAAE,CACb,CAEA,+BAAI,CACF,OAAO,CAAE,KAAK,CACd,IAAI,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAC5C,OAAO,CAAE,IAAI,CACb,OAAO,CAAE,IACX,CAEA,wCAAa,CACX,gBAAgB,CAAE,WAAW,CAC7B,KAAK,CAAE,MAAM,CACb,MAAM,CAAE,MAAM,CACd,WAAW,CAAE,CAAC,CACd,aAAa,CAAE,GAAG,CAClB,UAAU,CAAE,UAAU,CACtB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,WAAW,CAC7B,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MACnB,CACA,wCAAY,MAAO,CACjB,gBAAgB,CAAE,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,IAAI,CAAC,CAC3C,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,IAAI,CAC5C,CACA,0BAAY,CAAC,iBAAI,CACf,KAAK,CAAE,OAAO,CACd,MAAM,CAAE,OACV,CAEA,MAAM,yCAAc,CAClB,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,cAAc,CAAE,IAAI,CACpB,OAAO,CAAE,IAAI,CACb,KAAK,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAC7C,gBAAgB,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CACxD,aAAa,CAAE,GACjB,CAEA,oBAAM,MAAM,CAAG,MAAM,2BAAc,CACjC,YAAY,CAAE,IAAI,8BAA8B,CAAC,QAAQ,CAAC,CAC1D,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,IAAI,8BAA8B,CAAC,uBAAuB,CACxF,CAEA,kCAAM,KAAK,aAAa,CAAE,CACxB,OAAO,CAAE,CACX,CAEA,kCAAO,CACL,SAAS,CAAE,OAAO,CAClB,WAAW,CAAE,OAAO,CACpB,kBAAkB,CAAE,IAAI,CACxB,eAAe,CAAE,IAAI,CACrB,UAAU,CAAE,IAAI,CAChB,SAAS,CAAE,CAAC,CACZ,OAAO,CAAE,IAAI,CAAC,OAAO,CACrB,MAAM,CAAE,MAAM,CACd,aAAa,CAAE,MAAM,CACrB,MAAM,CAAE,GAAG,CACX,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAC1C,OAAO,CAAE,IAAI,CACb,UAAU,CAAE,GAAG,CAAC,IAAI,CAAC,aAAa,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,CACjD,gBAAgB,CAAE,IACpB,CAEA,mCAAQ,CACN,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,GAAG,CAChB,cAAc,CAAE,GAClB,CAEA,wCAAa,CACX,KAAK,CAAE,QAAQ,CACf,UAAU,CAAE,MAAM,CAClB,SAAS,CAAE,CACb,CAEA,iCAAM,CACJ,OAAO,CAAE,IACX,CAEA,iCAAM,CACJ,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MAAM,CACvB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,OAAO,CACf,SAAS,CAAE,CAAC,CACZ,aAAa,CAAE,GAAG,CAClB,UAAU,CAAE,UAAU,CACtB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,WACpB,CACA,iCAAK,MAAO,CACV,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,IAAI,CAC5C,CACA,KAAK,kCAAO,CACV,WAAW,CAAE,GAAG,CAChB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,0BAA0B,CAAC,yBAAyB,CAC5E,CACA,iCAAK,MAAO,CACV,gBAAgB,CAAE,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,IAAI,CAC5C,CACA,KAAK,qCAAU,CACb,UAAU,CAAE,MACd,CACA,KAAK,qCAAS,MAAO,CACnB,MAAM,CAAE,IAAI,CACZ,gBAAgB,CAAE,WACpB,CACA,KAAK,0BAAY,CAAC,kBAAK,CACrB,OAAO,CAAE,GACX,CACA,KAAK,qCAAU,CACb,KAAK,CAAE,IAAI,4BAA4B,CAAC,QAAQ,CAAC,CACjD,UAAU,CAAE,IAAI,iCAAiC,CAAC,uBAAuB,CAAC,CAC1E,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,8BAA8B,CAAC,QAAQ,CAC/D"}'
};
function cloneDate$1(d) {
  return new Date(d.getTime());
}
function clamp(d, min2, max2) {
  if (d > max2) {
    return cloneDate$1(max2);
  } else if (d < min2) {
    return cloneDate$1(min2);
  } else {
    return cloneDate$1(d);
  }
}
function clampDate(d, min2, max2) {
  const limit = clamp(d, min2, max2);
  if (limit.getTime() !== d.getTime()) {
    d = new Date(limit.getFullYear(), limit.getMonth(), limit.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
    d = clamp(d, min2, max2);
  }
  return d;
}
function getYears(min2, max2) {
  let years2 = [];
  for (let i = min2.getFullYear(); i <= max2.getFullYear(); i++) {
    years2.push(i);
  }
  return years2;
}
function dayIsInRange(calendarDay, min2, max2) {
  const date = new Date(calendarDay.year, calendarDay.month, calendarDay.number);
  const minDate = new Date(min2.getFullYear(), min2.getMonth(), min2.getDate());
  const maxDate = new Date(max2.getFullYear(), max2.getMonth(), max2.getDate());
  return date >= minDate && date <= maxDate;
}
const DatePicker = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let iLocale;
  let browseYear;
  let browseMonth;
  let calendarDays;
  createEventDispatcher();
  let { value: value2 = null } = $$props;
  function setValue(d) {
    if (d.getTime() !== value2?.getTime()) {
      browseDate = clamp(d, min, max);
      value2 = cloneDate$1(browseDate);
    }
  }
  function setTime(d) {
    browseDate = clamp(d, min, max);
    if (value2) {
      setValue(browseDate);
    }
    return browseDate;
  }
  const todayDate = /* @__PURE__ */ new Date();
  const defaultDate = /* @__PURE__ */ new Date();
  let { timePrecision = null } = $$props;
  let { min = new Date(defaultDate.getFullYear() - 20, 0, 1) } = $$props;
  let { max = new Date(defaultDate.getFullYear(), 11, 31, 23, 59, 59, 999) } = $$props;
  let browseDate = value2 ? cloneDate$1(value2) : cloneDate$1(clampDate(defaultDate, min, max));
  function setBrowseDate(value22) {
    if (browseDate.getTime() !== value22?.getTime()) {
      browseDate = value22 ? cloneDate$1(value22) : browseDate;
    }
  }
  let years = getYears(min, max);
  let { locale = {} } = $$props;
  let { browseWithoutSelecting = false } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.timePrecision === void 0 && $$bindings.timePrecision && timePrecision !== void 0) $$bindings.timePrecision(timePrecision);
  if ($$props.min === void 0 && $$bindings.min && min !== void 0) $$bindings.min(min);
  if ($$props.max === void 0 && $$bindings.max && max !== void 0) $$bindings.max(max);
  if ($$props.locale === void 0 && $$bindings.locale && locale !== void 0) $$bindings.locale(locale);
  if ($$props.browseWithoutSelecting === void 0 && $$bindings.browseWithoutSelecting && browseWithoutSelecting !== void 0) $$bindings.browseWithoutSelecting(browseWithoutSelecting);
  $$result.css.add(css$1);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      if (value2 && value2 > max) {
        setValue(max);
      } else if (value2 && value2 < min) {
        setValue(min);
      }
    }
    {
      setBrowseDate(value2);
    }
    years = getYears(min, max);
    iLocale = getInnerLocale(locale);
    browseYear = browseDate.getFullYear();
    browseMonth = browseDate.getMonth();
    calendarDays = getCalendarDays(browseDate, iLocale.weekStartsOn);
    $$rendered = `  <div class="date-time-picker svelte-go79cf" tabindex="0"><div class="tab-container svelte-go79cf" tabindex="-1"><div class="top svelte-go79cf"><button type="button" aria-label="Previous month" class="page-button svelte-go79cf" tabindex="-1" data-svelte-h="svelte-v2azqq"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svelte-go79cf"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" transform="rotate(180, 12, 12)"></path></svg></button> <div class="dropdown month svelte-go79cf"><select${add_attribute("value", browseMonth, 0)} class="svelte-go79cf">${each(iLocale.months, (monthName, i) => {
      return `<option ${new Date(browseYear, i, getMonthLength(browseYear, i), 23, 59, 59, 999) < min || new Date(browseYear, i) > max ? "disabled" : ""}${add_attribute("value", i, 0)}>${escape(monthName)}</option>`;
    })}</select>  <select class="dummy-select svelte-go79cf" tabindex="-1">${each(iLocale.months, (monthName, i) => {
      return `<option${add_attribute("value", i, 0)} ${i === browseMonth ? "selected" : ""}>${escape(monthName)}</option>`;
    })}</select> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svelte-go79cf"><path d="M6 0l12 12-12 12z" transform="rotate(90, 12, 12)"></path></svg></div> <div class="dropdown year svelte-go79cf"><select${add_attribute("value", browseYear, 0)} class="svelte-go79cf">${each(years, (v) => {
      return `<option${add_attribute("value", v, 0)}>${escape(v)}</option>`;
    })}</select>  <select class="dummy-select svelte-go79cf" tabindex="-1">${each(years, (v) => {
      return `<option${add_attribute("value", v, 0)} ${v === browseDate.getFullYear() ? "selected" : ""}>${escape(v)}</option>`;
    })}</select> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svelte-go79cf"><path d="M6 0l12 12-12 12z" transform="rotate(90, 12, 12)"></path></svg></div> <button type="button" aria-label="Next month" class="page-button svelte-go79cf" tabindex="-1" data-svelte-h="svelte-ft7e2n"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svelte-go79cf"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button></div> <div class="header svelte-go79cf"> ${each(Array(7), (_, i) => {
      return `${i + iLocale.weekStartsOn < 7 ? `<div class="header-cell svelte-go79cf">${escape(iLocale.weekdays[iLocale.weekStartsOn + i])}</div>` : `<div class="header-cell svelte-go79cf">${escape(iLocale.weekdays[iLocale.weekStartsOn + i - 7])}</div>`}`;
    })}</div>  ${each(Array(6), (_, weekIndex) => {
      return `<div class="week svelte-go79cf">${each(calendarDays.slice(weekIndex * 7, weekIndex * 7 + 7), (calendarDay) => {
        return ` <div class="${[
          "cell svelte-go79cf",
          (!dayIsInRange(calendarDay, min, max) ? "disabled" : "") + " " + (value2 && calendarDay.year === value2.getFullYear() && calendarDay.month === value2.getMonth() && calendarDay.number === value2.getDate() ? "selected" : "") + " " + (calendarDay.year === todayDate.getFullYear() && calendarDay.month === todayDate.getMonth() && calendarDay.number === todayDate.getDate() ? "today" : "") + " " + (calendarDay.month !== browseMonth ? "other-month" : "")
        ].join(" ").trim()}"><span class="svelte-go79cf">${escape(calendarDay.number)}</span> </div>`;
      })} </div>`;
    })} ${validate_component(TimePicker, "TimePicker").$$render(
      $$result,
      { timePrecision, setTime, browseDate },
      {
        browseDate: ($$value) => {
          browseDate = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${slots.default ? slots.default({}) : ``}</div> </div>`;
  } while (!$$settled);
  return $$rendered;
});
function parse(str, tokens, baseDate) {
  let missingPunctuation = "";
  let valid = true;
  baseDate = baseDate || new Date(2020, 0, 1, 0, 0, 0, 0);
  let year = baseDate.getFullYear();
  let month = baseDate.getMonth();
  let day = baseDate.getDate();
  let hours = baseDate.getHours();
  let minutes = baseDate.getMinutes();
  let seconds = baseDate.getSeconds();
  const ms = baseDate.getMilliseconds();
  function parseString(token) {
    for (let i = 0; i < token.length; i++) {
      if (str.startsWith(token[i])) {
        str = str.slice(1);
      } else {
        valid = false;
        if (str.length === 0)
          missingPunctuation = token.slice(i);
        return;
      }
    }
  }
  function parseUint(pattern, min, max) {
    const matches = str.match(pattern);
    if (matches?.[0]) {
      str = str.slice(matches[0].length);
      const n = parseInt(matches[0]);
      if (n > max || n < min) {
        valid = false;
        return null;
      } else {
        return n;
      }
    } else {
      valid = false;
      return null;
    }
  }
  function parseEnum(allowedValues) {
    const n = allowedValues.findIndex((allowedValue) => {
      return allowedValue.toLowerCase() === str.slice(0, allowedValue.length).toLowerCase();
    });
    if (n >= 0) {
      str = str.slice(allowedValues[n].length);
      return n;
    } else {
      valid = false;
      return null;
    }
  }
  function parseToken(token) {
    if (typeof token === "string") {
      parseString(token);
    } else if (token.id === "yy") {
      const value2 = parseUint(/^[0-9]{2}/, 0, 99);
      if (value2 !== null)
        year = 2e3 + value2;
    } else if (token.id === "yyyy") {
      const value2 = parseUint(/^[0-9]{4}/, 0, 9999);
      if (value2 !== null)
        year = value2;
    } else if (token.id === "MM") {
      const value2 = parseUint(/^[0-9]{2}/, 1, 12);
      if (value2 !== null)
        month = value2 - 1;
    } else if (token.id === "MMM") {
      const value2 = parseEnum(token.allowedValues || []);
      if (value2 !== null)
        month = value2;
    } else if (token.id === "dd") {
      const value2 = parseUint(/^[0-9]{2}/, 1, 31);
      if (value2 !== null)
        day = value2;
    } else if (token.id === "HH") {
      const value2 = parseUint(/^[0-9]{2}/, 0, 23);
      if (value2 !== null)
        hours = value2;
    } else if (token.id === "mm") {
      const value2 = parseUint(/^[0-9]{2}/, 0, 59);
      if (value2 !== null)
        minutes = value2;
    } else if (token.id === "ss") {
      const value2 = parseUint(/^[0-9]{2}/, 0, 59);
      if (value2 !== null)
        seconds = value2;
    }
  }
  for (const token of tokens) {
    parseToken(token);
    if (!valid)
      break;
  }
  const monthLength = getMonthLength(year, month);
  if (day > monthLength) {
    valid = false;
  }
  return {
    date: valid ? new Date(year, month, day, hours, minutes, seconds, ms) : null,
    missingPunctuation
  };
}
function twoDigit(value2) {
  return ("0" + value2.toString()).slice(-2);
}
function parseRule(s, innerLocale) {
  if (s.startsWith("yyyy")) {
    return {
      id: "yyyy",
      toString: (d) => d.getFullYear().toString()
    };
  } else if (s.startsWith("yy")) {
    return {
      id: "yy",
      toString: (d) => d.getFullYear().toString().slice(-2)
    };
  } else if (s.startsWith("MMM")) {
    return {
      id: "MMM",
      allowedValues: innerLocale.shortMonths,
      toString: (d) => innerLocale.shortMonths[d.getMonth()]
    };
  } else if (s.startsWith("MM")) {
    return {
      id: "MM",
      toString: (d) => twoDigit(d.getMonth() + 1)
    };
  } else if (s.startsWith("dd")) {
    return {
      id: "dd",
      toString: (d) => twoDigit(d.getDate())
    };
  } else if (s.startsWith("HH")) {
    return {
      id: "HH",
      toString: (d) => twoDigit(d.getHours())
    };
  } else if (s.startsWith("mm")) {
    return {
      id: "mm",
      toString: (d) => twoDigit(d.getMinutes())
    };
  } else if (s.startsWith("ss")) {
    return {
      id: "ss",
      toString: (d) => twoDigit(d.getSeconds())
    };
  }
}
function createFormat(s, locale = {}) {
  const innerLocale = getInnerLocale(locale);
  const tokens = [];
  while (s.length > 0) {
    const token = parseRule(s, innerLocale);
    if (token) {
      tokens.push(token);
      s = s.slice(token.id.length);
    } else if (typeof tokens[tokens.length - 1] === "string") {
      tokens[tokens.length - 1] += s[0];
      s = s.slice(1);
    } else {
      tokens.push(s[0]);
      s = s.slice(1);
    }
  }
  return tokens;
}
const css = {
  code: ".date-time-field.svelte-1vabmef{position:relative}input.svelte-1vabmef{color:var(--date-picker-foreground, #000000);background:var(--date-picker-background, #ffffff);min-width:0px;box-sizing:border-box;padding:4px 6px;margin:0px;border:1px solid rgba(103, 113, 137, 0.3);border-radius:3px;width:var(--date-input-width, 150px);outline:none;transition:all 80ms cubic-bezier(0.4, 0, 0.2, 1)}input.svelte-1vabmef:focus{border-color:var(--date-picker-highlight-border, #0269f7);box-shadow:0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4))}input.svelte-1vabmef:disabled{opacity:0.5}.invalid.svelte-1vabmef{border:1px solid rgba(249, 47, 114, 0.5);background-color:rgba(249, 47, 114, 0.1)}.invalid.svelte-1vabmef:focus{border-color:#f92f72;box-shadow:0px 0px 0px 2px rgba(249, 47, 114, 0.5)}.picker.svelte-1vabmef{display:none;position:absolute;padding:1px;left:var(--picker-left-position);z-index:10}.picker.above.svelte-1vabmef{bottom:100%}.picker.visible.svelte-1vabmef{display:block}",
  map: `{"version":3,"file":"DateInput.svelte","sources":["DateInput.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { fly } from \\"svelte/transition\\";\\nimport { cubicInOut } from \\"svelte/easing\\";\\nimport { toText } from \\"./date-utils.js\\";\\nimport { parse, createFormat } from \\"./parse.js\\";\\nimport DateTimePicker from \\"./DatePicker.svelte\\";\\nimport { writable } from \\"svelte/store\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nconst dispatch = createEventDispatcher();\\nconst defaultDate = /* @__PURE__ */ new Date();\\nfunction cloneDate(d) {\\n  return new Date(d.getTime());\\n}\\nconst innerStore = writable(null);\\nconst store = (() => {\\n  return {\\n    subscribe: innerStore.subscribe,\\n    set: (date) => {\\n      if (date === null || date === void 0) {\\n        innerStore.set(null);\\n        value = date;\\n      } else if (date.getTime() !== $innerStore?.getTime()) {\\n        innerStore.set(cloneDate(date));\\n        value = date;\\n      }\\n    }\\n  };\\n})();\\nexport let value = null;\\n$: store.set(value);\\nexport let min = new Date(defaultDate.getFullYear() - 20, 0, 1);\\nexport let max = new Date(defaultDate.getFullYear(), 11, 31, 23, 59, 59, 999);\\nexport let id = null;\\nexport let placeholder = \\"2020-12-31 23:00:00\\";\\nexport let valid = true;\\nexport let disabled = false;\\nexport let required = false;\\nlet classes = \\"\\";\\nexport { classes as class };\\nexport let locale = {};\\nexport let format = \\"yyyy-MM-dd HH:mm:ss\\";\\nlet formatTokens = createFormat(format, locale);\\n$: formatTokens = createFormat(format, locale);\\nfunction valueUpdate(value2, formatTokens2) {\\n  text = toText(value2, formatTokens2);\\n}\\n$: valueUpdate($store, formatTokens);\\nexport let text = toText($store, formatTokens);\\nfunction textUpdate(text2, formatTokens2) {\\n  if (text2.length) {\\n    const result = parse(text2, formatTokens2, $store);\\n    if (result.date !== null) {\\n      valid = true;\\n      store.set(result.date);\\n    } else {\\n      valid = false;\\n    }\\n  } else {\\n    valid = true;\\n    if (value) {\\n      value = null;\\n      store.set(null);\\n    }\\n  }\\n}\\n$: textUpdate(text, formatTokens);\\nexport let visible = false;\\nexport let closeOnSelection = false;\\nexport let browseWithoutSelecting = false;\\nexport let timePrecision = null;\\nfunction onFocusOut(e) {\\n  if (e?.currentTarget instanceof HTMLElement && e.relatedTarget && e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget)) {\\n    return;\\n  } else {\\n    visible = false;\\n  }\\n}\\nfunction keydown(e) {\\n  if (e.key === \\"Escape\\" && visible) {\\n    visible = false;\\n    e.preventDefault();\\n    e.stopPropagation();\\n  } else if (e.key === \\"Enter\\") {\\n    visible = !visible;\\n    e.preventDefault();\\n  }\\n}\\nfunction onSelect(e) {\\n  dispatch(\\"select\\", e.detail);\\n  if (closeOnSelection) {\\n    visible = false;\\n  }\\n}\\nexport let dynamicPositioning = false;\\nlet InputElement;\\nlet pickerElement;\\nlet showAbove = false;\\nlet pickerLeftPosition = null;\\nfunction setDatePickerPosition() {\\n  showAbove = false;\\n  pickerLeftPosition = null;\\n  if (visible && pickerElement && dynamicPositioning) {\\n    const inputRect = InputElement.getBoundingClientRect();\\n    const horizontalOverflow = pickerElement.offsetWidth - inputRect.width;\\n    const bottomThreshold = inputRect.bottom + pickerElement.offsetHeight + 5;\\n    const rightThreshold = inputRect.left + pickerElement.offsetWidth + 5;\\n    if (bottomThreshold > window.innerHeight) {\\n      showAbove = true;\\n    }\\n    if (rightThreshold > window.innerWidth) {\\n      pickerLeftPosition = -horizontalOverflow;\\n      if (inputRect.left < horizontalOverflow + 5) {\\n        const windowCenterPos = window.innerWidth / 2;\\n        const newPos = windowCenterPos - pickerElement.offsetWidth / 2;\\n        pickerLeftPosition = newPos - inputRect.left;\\n      }\\n    }\\n  }\\n}\\nfunction flyAutoPosition(node) {\\n  setDatePickerPosition();\\n  return fly(node, {\\n    duration: 200,\\n    easing: cubicInOut,\\n    y: showAbove ? 5 : -5\\n  });\\n}\\n<\/script>\\n\\n<!-- svelte-ignore a11y-no-static-element-interactions -->\\n<div class=\\"date-time-field {classes}\\" on:focusout={onFocusOut} on:keydown={keydown}>\\n\\t<input\\n\\t\\tbind:this={InputElement}\\n\\t\\tclass:invalid={!valid}\\n\\t\\ttype=\\"text\\"\\n\\t\\tautocomplete=\\"off\\"\\n\\t\\tvalue={text}\\n\\t\\t{id}\\n\\t\\t{placeholder}\\n\\t\\t{disabled}\\n\\t\\t{required}\\n\\t\\ton:focus={() => (visible = true)}\\n\\t\\ton:mousedown={() => (visible = true)}\\n\\t\\ton:input={(e) => {\\n\\t\\t\\tif (\\n\\t\\t\\t\\te instanceof InputEvent &&\\n\\t\\t\\t\\te.inputType === 'insertText' &&\\n\\t\\t\\t\\ttypeof e.data === 'string' &&\\n\\t\\t\\t\\te.currentTarget.value === text + e.data\\n\\t\\t\\t) {\\n\\t\\t\\t\\t// check for missing punctuation, and add if there is any\\n\\t\\t\\t\\tlet result = parse(text, formatTokens, $store)\\n\\t\\t\\t\\tif (result.missingPunctuation !== '' && !result.missingPunctuation.startsWith(e.data)) {\\n\\t\\t\\t\\t\\ttext = text + result.missingPunctuation + e.data\\n\\t\\t\\t\\t\\treturn\\n\\t\\t\\t\\t}\\n\\t\\t\\t}\\n\\t\\t\\ttext = e.currentTarget.value\\n\\t\\t}}\\n\\t/>\\n\\t{#if visible && !disabled}\\n\\t\\t<div\\n\\t\\t\\tclass=\\"picker\\"\\n\\t\\t\\tclass:visible\\n\\t\\t\\tclass:above={showAbove}\\n\\t\\t\\ttransition:flyAutoPosition\\n\\t\\t\\tbind:this={pickerElement}\\n\\t\\t\\tstyle:--picker-left-position=\\"{pickerLeftPosition}px\\"\\n\\t\\t>\\n\\t\\t\\t<DateTimePicker\\n\\t\\t\\t\\ton:focusout={onFocusOut}\\n\\t\\t\\t\\ton:select={onSelect}\\n\\t\\t\\t\\tbind:value={$store}\\n\\t\\t\\t\\t{min}\\n\\t\\t\\t\\t{max}\\n\\t\\t\\t\\t{locale}\\n\\t\\t\\t\\t{browseWithoutSelecting}\\n\\t\\t\\t\\t{timePrecision}\\n\\t\\t\\t>\\n\\t\\t\\t\\t<slot />\\n\\t\\t\\t</DateTimePicker>\\n\\t\\t</div>\\n\\t{/if}\\n</div>\\n\\n<style>.date-time-field {\\n  position: relative;\\n}\\n\\ninput {\\n  color: var(--date-picker-foreground, #000000);\\n  background: var(--date-picker-background, #ffffff);\\n  min-width: 0px;\\n  box-sizing: border-box;\\n  padding: 4px 6px;\\n  margin: 0px;\\n  border: 1px solid rgba(103, 113, 137, 0.3);\\n  border-radius: 3px;\\n  width: var(--date-input-width, 150px);\\n  outline: none;\\n  transition: all 80ms cubic-bezier(0.4, 0, 0.2, 1);\\n}\\ninput:focus {\\n  border-color: var(--date-picker-highlight-border, #0269f7);\\n  box-shadow: 0px 0px 0px 2px var(--date-picker-highlight-shadow, rgba(2, 105, 247, 0.4));\\n}\\ninput:disabled {\\n  opacity: 0.5;\\n}\\n\\n.invalid {\\n  border: 1px solid rgba(249, 47, 114, 0.5);\\n  background-color: rgba(249, 47, 114, 0.1);\\n}\\n.invalid:focus {\\n  border-color: #f92f72;\\n  box-shadow: 0px 0px 0px 2px rgba(249, 47, 114, 0.5);\\n}\\n\\n.picker {\\n  display: none;\\n  position: absolute;\\n  padding: 1px;\\n  left: var(--picker-left-position);\\n  z-index: 10;\\n}\\n.picker.above {\\n  bottom: 100%;\\n}\\n.picker.visible {\\n  display: block;\\n}</style>\\n"],"names":[],"mappings":"AAwLO,+BAAiB,CACtB,QAAQ,CAAE,QACZ,CAEA,oBAAM,CACJ,KAAK,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAC7C,UAAU,CAAE,IAAI,wBAAwB,CAAC,QAAQ,CAAC,CAClD,SAAS,CAAE,GAAG,CACd,UAAU,CAAE,UAAU,CACtB,OAAO,CAAE,GAAG,CAAC,GAAG,CAChB,MAAM,CAAE,GAAG,CACX,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CAC1C,aAAa,CAAE,GAAG,CAClB,KAAK,CAAE,IAAI,kBAAkB,CAAC,MAAM,CAAC,CACrC,OAAO,CAAE,IAAI,CACb,UAAU,CAAE,GAAG,CAAC,IAAI,CAAC,aAAa,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,CAClD,CACA,oBAAK,MAAO,CACV,YAAY,CAAE,IAAI,8BAA8B,CAAC,QAAQ,CAAC,CAC1D,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,IAAI,8BAA8B,CAAC,uBAAuB,CACxF,CACA,oBAAK,SAAU,CACb,OAAO,CAAE,GACX,CAEA,uBAAS,CACP,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,GAAG,CAAC,CAAC,EAAE,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,CACzC,gBAAgB,CAAE,KAAK,GAAG,CAAC,CAAC,EAAE,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAC1C,CACA,uBAAQ,MAAO,CACb,YAAY,CAAE,OAAO,CACrB,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,KAAK,GAAG,CAAC,CAAC,EAAE,CAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CACpD,CAEA,sBAAQ,CACN,OAAO,CAAE,IAAI,CACb,QAAQ,CAAE,QAAQ,CAClB,OAAO,CAAE,GAAG,CACZ,IAAI,CAAE,IAAI,sBAAsB,CAAC,CACjC,OAAO,CAAE,EACX,CACA,OAAO,qBAAO,CACZ,MAAM,CAAE,IACV,CACA,OAAO,uBAAS,CACd,OAAO,CAAE,KACX"}`
};
function cloneDate(d) {
  return new Date(d.getTime());
}
const DateInput = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $store, $$unsubscribe_store;
  let $innerStore, $$unsubscribe_innerStore;
  createEventDispatcher();
  const defaultDate = /* @__PURE__ */ new Date();
  const innerStore = writable(null);
  $$unsubscribe_innerStore = subscribe(innerStore, (value3) => $innerStore = value3);
  const store = (() => {
    return {
      subscribe: innerStore.subscribe,
      set: (date) => {
        if (date === null || date === void 0) {
          innerStore.set(null);
          value2 = date;
        } else if (date.getTime() !== $innerStore?.getTime()) {
          innerStore.set(cloneDate(date));
          value2 = date;
        }
      }
    };
  })();
  $$unsubscribe_store = subscribe(store, (value3) => $store = value3);
  let { value: value2 = null } = $$props;
  let { min = new Date(defaultDate.getFullYear() - 20, 0, 1) } = $$props;
  let { max = new Date(defaultDate.getFullYear(), 11, 31, 23, 59, 59, 999) } = $$props;
  let { id = null } = $$props;
  let { placeholder = "2020-12-31 23:00:00" } = $$props;
  let { valid = true } = $$props;
  let { disabled = false } = $$props;
  let { required = false } = $$props;
  let { class: classes = "" } = $$props;
  let { locale = {} } = $$props;
  let { format = "yyyy-MM-dd HH:mm:ss" } = $$props;
  let formatTokens = createFormat(format, locale);
  function valueUpdate(value22, formatTokens2) {
    text = toText(value22, formatTokens2);
  }
  let { text = toText($store, formatTokens) } = $$props;
  function textUpdate(text2, formatTokens2) {
    if (text2.length) {
      const result = parse(text2, formatTokens2, $store);
      if (result.date !== null) {
        valid = true;
        store.set(result.date);
      } else {
        valid = false;
      }
    } else {
      valid = true;
      if (value2) {
        value2 = null;
        store.set(null);
      }
    }
  }
  let { visible = false } = $$props;
  let { closeOnSelection = false } = $$props;
  let { browseWithoutSelecting = false } = $$props;
  let { timePrecision = null } = $$props;
  let { dynamicPositioning = false } = $$props;
  let InputElement;
  let pickerElement;
  let pickerLeftPosition = null;
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.min === void 0 && $$bindings.min && min !== void 0) $$bindings.min(min);
  if ($$props.max === void 0 && $$bindings.max && max !== void 0) $$bindings.max(max);
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0) $$bindings.placeholder(placeholder);
  if ($$props.valid === void 0 && $$bindings.valid && valid !== void 0) $$bindings.valid(valid);
  if ($$props.disabled === void 0 && $$bindings.disabled && disabled !== void 0) $$bindings.disabled(disabled);
  if ($$props.required === void 0 && $$bindings.required && required !== void 0) $$bindings.required(required);
  if ($$props.class === void 0 && $$bindings.class && classes !== void 0) $$bindings.class(classes);
  if ($$props.locale === void 0 && $$bindings.locale && locale !== void 0) $$bindings.locale(locale);
  if ($$props.format === void 0 && $$bindings.format && format !== void 0) $$bindings.format(format);
  if ($$props.text === void 0 && $$bindings.text && text !== void 0) $$bindings.text(text);
  if ($$props.visible === void 0 && $$bindings.visible && visible !== void 0) $$bindings.visible(visible);
  if ($$props.closeOnSelection === void 0 && $$bindings.closeOnSelection && closeOnSelection !== void 0) $$bindings.closeOnSelection(closeOnSelection);
  if ($$props.browseWithoutSelecting === void 0 && $$bindings.browseWithoutSelecting && browseWithoutSelecting !== void 0) $$bindings.browseWithoutSelecting(browseWithoutSelecting);
  if ($$props.timePrecision === void 0 && $$bindings.timePrecision && timePrecision !== void 0) $$bindings.timePrecision(timePrecision);
  if ($$props.dynamicPositioning === void 0 && $$bindings.dynamicPositioning && dynamicPositioning !== void 0) $$bindings.dynamicPositioning(dynamicPositioning);
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      store.set(value2);
    }
    formatTokens = createFormat(format, locale);
    {
      valueUpdate($store, formatTokens);
    }
    {
      textUpdate(text, formatTokens);
    }
    $$rendered = ` <div class="${"date-time-field " + escape(classes, true) + " svelte-1vabmef"}"><input type="text" autocomplete="off"${add_attribute("value", text, 0)}${add_attribute("id", id, 0)}${add_attribute("placeholder", placeholder, 0)} ${disabled ? "disabled" : ""} ${required ? "required" : ""} class="${["svelte-1vabmef", !valid ? "invalid" : ""].join(" ").trim()}"${add_attribute("this", InputElement, 0)}> ${visible && !disabled ? `<div class="${[
      "picker svelte-1vabmef",
      (visible ? "visible" : "") + " "
    ].join(" ").trim()}"${add_styles({
      "--picker-left-position": `${pickerLeftPosition}px`
    })}${add_attribute("this", pickerElement, 0)}>${validate_component(DatePicker, "DateTimePicker").$$render(
      $$result,
      {
        min,
        max,
        locale,
        browseWithoutSelecting,
        timePrecision,
        value: $store
      },
      {
        value: ($$value) => {
          $store = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${slots.default ? slots.default({}) : ``}`;
        }
      }
    )}</div>` : ``} </div>`;
  } while (!$$settled);
  $$unsubscribe_store();
  $$unsubscribe_innerStore();
  return $$rendered;
});
const GeneralModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { showModal = false } = $$props;
  let { title = "Modal" } = $$props;
  let { extract = () => {
  } } = $$props;
  if ($$props.showModal === void 0 && $$bindings.showModal && showModal !== void 0) $$bindings.showModal(showModal);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.extract === void 0 && $$bindings.extract && extract !== void 0) $$bindings.extract(extract);
  return `${showModal ? `<div class="relative z-20" aria-labelledby="modal-title" role="dialog" aria-modal="true"> <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div> <div class="fixed inset-0 z-10 overflow-y-auto"><div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"> <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"><div class="mb-5 pb-3 grid gap-3 grid-cols-2 justify-between border-b border-neutral-300"><div class="text-lg self-center">${escape(title)}</div> <div class="grid justify-end"><button type="button" class="bg-red-500 mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-600 sm:mt-0" data-svelte-h="svelte-7b4ckr"><svg class="w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></button></div></div> <div>${slots.default ? slots.default({}) : ``}</div></div></div></div></div>` : ``}`;
});
const WizardVenue = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let showModal = false;
  let newAddress = {};
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(GeneralModal, "GeneralModal").$$render(
      $$result,
      { title: "Neue Adresse", showModal },
      {
        showModal: ($$value) => {
          showModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<form><div class="grid gap-3 grid-cols-5"><div class="input col-span-6"><label for="name" data-svelte-h="svelte-bs9sy6">Name</label> <input id="name" type="text" required${add_attribute("value", newAddress.name, 0)}></div> <div class="input col-span-4"><label for="street" data-svelte-h="svelte-1tfod5c">Strasse</label> <input type="text" id="street" required${add_attribute("value", newAddress.street, 0)}></div> <div class="input col-span-2"><label for="number" data-svelte-h="svelte-1qdk27j">Nummer</label> <input type="text" id="number" required${add_attribute("value", newAddress.number, 0)}></div> <div class="input col-span-3"><label for="place" data-svelte-h="svelte-14fs82c">Ort</label> <input type="text" id="place" required${add_attribute("value", newAddress.place, 0)}></div> <div class="input col-span-3"><label for="zip" data-svelte-h="svelte-1joq440">Postleitzahl</label> <input type="text" id="zip" required${add_attribute("value", newAddress.zip, 0)}></div> <div class="input col-span-6"><label for="country" data-svelte-h="svelte-1t4ox5z">Land</label> <select id="country" required><option value="Deutschland" data-svelte-h="svelte-15we31c">Deutschland</option><option value="Österreich" data-svelte-h="svelte-18ir50e">Österreich</option><option value="Schweiz" data-svelte-h="svelte-7tmlk0">Schweiz</option></select></div> ${`<div class="col-span-6 place-self-end pt-5" data-svelte-h="svelte-d6xlcx"><button type="submit" class="place-self-end inline-flex items-center gap-x-2 rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"><svg class="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>
                        Speichern</button></div>`}</div></form>`;
        }
      }
    )} ${`${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return `
        Loading...
    `;
      }
      return function(addresses) {
        return ` <h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-84fxvk">Veranstaltungsort</h3> <div class="grid gap-3">${validate_component(Typeahead, "Typeahead").$$render(
          $$result,
          {
            icon: "map-pin-alt-solid",
            value: addresses.find((x) => x.uuid === project.addressUuid)?.name,
            label: "Location",
            data: addresses,
            extract: (selected) => project.addressUuid = selected.uuid
          },
          {},
          {
            "no-results": () => {
              return `<div class="flex gap-3 cursor-pointer"><svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> <div>Adresse &quot;<strong>${escape(value)}</strong>&quot; anlegen.</div></div> `;
            },
            default: ({ item, value: value2 }) => {
              return `<div class="cursor-pointer"><div class="font-bold text-neutral-800">${escape(item.name)}</div> <div class="text-sm text-neutral-500">${escape(item.street)} ${escape(item.number)} <br> ${escape(item.place)}</div></div>`;
            }
          }
        )} <div>${project.addressUuid ? `<iframe width="100%" height="300" id="gmap_canvas"${add_attribute("src", `https://maps.google.com/maps?q=${addresses.find((x) => x.uuid === project.addressUuid)?.street.replace(/\s/, "%20")}%20${addresses.find((x) => x.uuid === project.addressUuid)?.number}%20${addresses.find((x) => x.uuid === project.addressUuid)?.place}%20${addresses.find((x) => x.uuid === project.addressUuid)?.country}&t=&z=16&ie=UTF8&iwloc=&output=embed`, 0)} frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>` : ``}</div></div> `;
      }(__value);
    }(availableAddresses())}`}`;
  } while (!$$settled);
  return $$rendered;
});
const SuggestInput = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { id = "input-" + Math.random().toString(36) } = $$props;
  let { label = "" } = $$props;
  let { value: value2 = "" } = $$props;
  let { key } = $$props;
  let { icon = PenNibSolid } = $$props;
  let { extract = (item) => item } = $$props;
  let searchRef = null;
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.value === void 0 && $$bindings.value && value2 !== void 0) $$bindings.value(value2);
  if ($$props.key === void 0 && $$bindings.key && key !== void 0) $$bindings.key(key);
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0) $$bindings.icon(icon);
  if ($$props.extract === void 0 && $$bindings.extract && extract !== void 0) $$bindings.extract(extract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="relative">  ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 mb-3 " }, {}, {
      default: () => {
        return `<span>${escape(label)}</span> ${validate_component(Input, "Input").$$render(
          $$result,
          { required: true, this: searchRef, value: value2 },
          {
            this: ($$value) => {
              searchRef = $$value;
              $$settled = false;
            },
            value: ($$value) => {
              value2 = $$value;
              $$settled = false;
            }
          },
          {
            left: () => {
              return `${validate_component(IconSolid, "IconSolid").$$render(
                $$result,
                {
                  slot: "left",
                  class: "text-primary-400",
                  icon
                },
                {},
                {}
              )}`;
            }
          }
        )}`;
      }
    })}</div>`;
  } while (!$$settled);
  return $$rendered;
});
const WizardGeneral = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  currentCustomer.subscribe(async (x) => {
    availableAssociates.set(await availableProjectLeaders());
  });
  let associates;
  let loading = true;
  availableAssociates.subscribe((people) => {
    if (people) {
      associates = people;
      loading = false;
    }
  });
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${loading ? `Loading...` : `<h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-ouf42u">Allgemeine Informationen</h3> ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 mb-3" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-16106w">Projektname</span> ${validate_component(Input, "Input").$$render(
          $$result,
          { required: true, value: project.name },
          {
            value: ($$value) => {
              project.name = $$value;
              $$settled = false;
            }
          },
          {
            left: () => {
              return `${validate_component(GridSolid, "GridSolid").$$render($$result, { slot: "left", class: "text-primary-400" }, {}, {})}`;
            }
          }
        )}`;
      }
    })} <div class="grid gap-3 grid-cols-2 ">${validate_component(Typeahead, "Typeahead").$$render(
      $$result,
      {
        icon: UserSolid,
        value: associates.find((x) => x.id === project.responsibleAssociateId)?.name,
        label: "Ansprechpartner Projekt",
        data: associates,
        extract: (selected) => project.responsibleAssociateId = selected.id
      },
      {},
      {
        "no-results": () => {
          return `No results found for &quot;${escape(value)}&quot;`;
        }
      }
    )} ${validate_component(SuggestInput, "SuggestInput").$$render(
      $$result,
      {
        key: "department",
        icon: ClipboardListSolid,
        label: "Abteilung / Kostenstelle",
        value: project.store[project.store.findIndex((x) => x.identityKey === "department")].value
      },
      {
        value: ($$value) => {
          project.store[project.store.findIndex((x) => x.identityKey === "department")].value = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div> <div class="grid gap-3 grid-cols-2">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-1borbcw">Beginn der Veranstaltung</span> ${validate_component(DateInput, "DateInput").$$render(
          $$result,
          {
            format: "dd.MM.yyyy",
            closeOnSelection: true,
            browseWithoutSelecting: true,
            min: /* @__PURE__ */ new Date(),
            value: project.startsAt
          },
          {
            value: ($$value) => {
              project.startsAt = $$value;
              $$settled = false;
            }
          },
          {}
        )}`;
      }
    })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-jt7z9d">Ende der Veranstaltung</span> ${validate_component(DateInput, "DateInput").$$render(
          $$result,
          {
            format: "dd.MM.yyyy",
            closeOnSelection: true,
            browseWithoutSelecting: true,
            min: project.startsAt,
            value: project.endsAt
          },
          {
            value: ($$value) => {
              project.endsAt = $$value;
              $$settled = false;
            }
          },
          {}
        )}`;
      }
    })}</div> ${project.startsAt !== project.endsAt ? `<div class="grid gap-3 grid-cols-2 mt-3" data-svelte-h="svelte-du6v0u"><div class="relative flex items-start py-4"><div class="min-w-0 flex-1"><label for="separate" class="">In ein Projekt pro Tag aufteilen?</label></div> <div class="ml-3 flex h-6 items-center"><input id="separate" name="person-1" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"></div></div></div>` : ``}`}`;
  } while (!$$settled);
  return $$rendered;
});
let customerUUID;
currentCustomer.subscribe((val) => {
  if (val && typeof val.uuid !== "undefined") {
    customerUUID = val.uuid;
  }
});
const availableTags = async () => {
  if (typeof customerUUID === "undefined") {
    await Sleep(1e3);
  }
  return await get("/tag/" + customerUUID);
};
const WizardAdditional = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let tagPromise = availableTags();
  const handleProjectTag = (identifier, selected) => {
    const thisTag = project.tags.findIndex((x) => x.identifier === identifier);
    if (thisTag !== -1) {
      project.tags[thisTag] = selected;
    } else {
      project.tags = [...project.tags, selected];
    }
  };
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return ` <div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div> `;
      }
      return function(tags) {
        return ` <h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-razw68">Weitere Informationen</h3> <div class="grid grid-cols-2 gap-3"><div>${validate_component(Typeahead, "Typeahead").$$render(
          $$result,
          {
            icon: "la-utensils",
            value: project.tags[project.tags.findIndex((x) => x.identifier === "category")]?.name,
            label: "Kategorie",
            data: tags.filter((x) => x.identifier === "category"),
            extract: (selected) => handleProjectTag("category", selected)
          },
          {},
          {
            "no-results": () => {
              return `<div class="flex gap-3 cursor-pointer"><svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> <div>Kategorie &quot;<strong>${escape(value)}</strong>&quot; anlegen.</div></div>`;
            }
          }
        )}</div> <div>${validate_component(Typeahead, "Typeahead").$$render(
          $$result,
          {
            icon: "la-bullhorn",
            value: project.tags[project.tags.findIndex((x) => x.identifier === "occasion")]?.name,
            label: "Anlaß",
            data: tags.filter((x) => x.identifier === "occasion"),
            extract: (selected) => handleProjectTag("occasion", selected)
          },
          {},
          {
            "no-results": () => {
              return `<div class="flex gap-3 cursor-pointer"><svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> <div>Anlaß &quot;<strong>${escape(value)}</strong>&quot; anlegen.</div></div>`;
            }
          }
        )}</div> <div>${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
          default: () => {
            return `<span data-svelte-h="svelte-iejd1a">Erwartete Gäste</span> ${validate_component(Input, "Input").$$render(
              $$result,
              {
                type: "number",
                value: project.store[project.store.findIndex((x) => x.identityKey === "guests")].value
              },
              {
                value: ($$value) => {
                  project.store[project.store.findIndex((x) => x.identityKey === "guests")].value = $$value;
                  $$settled = false;
                }
              },
              {
                left: () => {
                  return `<i slot="left" class="la la-users text-[24px] text-primary-400"></i>`;
                }
              }
            )}`;
          }
        })}</div> <div>${validate_component(Typeahead, "Typeahead").$$render(
          $$result,
          {
            icon: "la-user-tie",
            value: project.tags[project.tags.findIndex((x) => x.identifier === "outfit")]?.name,
            label: "Dresscode",
            data: tags.filter((x) => x.identifier === "outfit"),
            extract: (selected) => handleProjectTag("outfit", selected)
          },
          {},
          {
            "no-results": () => {
              return `<div class="flex gap-3 cursor-pointer"><svg class="w-4 text-coolGray-500" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> <div>Dresscode &quot;<strong>${escape(value)}</strong>&quot; anlegen.</div></div>`;
            }
          }
        )}</div></div> `;
      }(__value);
    }(tagPromise)}`;
  } while (!$$settled);
  return $$rendered;
});
const WizardAssociated = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let { header = [
    { label: "Name", property: "name" },
    { label: "Email", property: "email" },
    {
      label: "Zeichnungsberechtigt",
      property: "isSignatory",
      component: Checkbox,
      props: {},
      class: "w-1/4"
    },
    {
      label: "Entfernen",
      property: "index",
      component: RemoveButton,
      props: {
        onClick: (index) => {
          project.associates = project.associates.filter((x, ind) => ind !== index);
        },
        classes: "text-center"
      },
      class: "w-8"
    }
  ] } = $$props;
  let unknownAssociate = { name: "", email: "" };
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  if ($$props.header === void 0 && $$bindings.header && header !== void 0) $$bindings.header(header);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return `
    Loading...
`;
      }
      return function(team) {
        return ` <h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-lzz66d">Weitere Ansprechpartner</h3> ${validate_component(SortableTable, "SortableTable").$$render(
          $$result,
          {
            emptyText: "Keine zusätzlichen Ansprechpartner ausgewählt",
            data: project.associates,
            header
          },
          {
            data: ($$value) => {
              project.associates = $$value;
              $$settled = false;
            },
            header: ($$value) => {
              header = $$value;
              $$settled = false;
            }
          },
          {}
        )} <h3 class="mt-5 text-md font-medium text-neutral-500" data-svelte-h="svelte-1vahbd4">Teammitglieder hinzufügen</h3> <ul role="list" class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">${team.filter((x) => x.userId !== project.responsibleAssociateId && (typeof project.associates == "undefined" || !project.associates.find((y) => y.id === x.id))).filter((x, i) => i < 6).length ? each(team.filter((x) => x.userId !== project.responsibleAssociateId && (typeof project.associates == "undefined" || !project.associates.find((y) => y.id === x.id))).filter((x, i) => i < 6), (member) => {
          return `<li><button type="button" class="text-neutral-600 group flex w-full items-center justify-between space-x-3 rounded-full border border-neutral-300 p-2 text-left shadow-sm hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-coolGray-500 focus:ring-offset-2"><span class="flex min-w-0 flex-1 items-center space-x-3"><span class="block flex-shrink-0"><div class="h-10 w-10 rounded-full bg-coolGray-400 flex justify-center items-center font-bold text-white">${escape(member.firstName[0])}${escape(member.lastName[0])} </div></span> <span class="block min-w-0 flex-1"><span class="block truncate text-sm font-medium text-neutral-900">${escape(member.name)}</span> <span class="block truncate text-sm font-medium text-neutral-500">${escape(member.email)}</span> </span></span> <span class="inline-flex h-10 w-17 flex-shrink-0 items-center justify-center pr-6" data-svelte-h="svelte-1mhjto8"> <svg class="h-5 w-5 text-coolGray-400 group-hover:text-neutral-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"></path></svg> </span></button> </li>`;
        }) : `<li data-svelte-h="svelte-19a7b81"><p class="py-5 text-red-400">Keine Teammitgliedervorschläge übrig</p> </li>`}</ul> ${team.length > 6 ? `<div class="text-center mt-7 mb-3"><button class="text-md font-medium text-neutral-500" data-svelte-h="svelte-nv6kyi">mehr laden</button></div> <div class="my-5 border-b" data-svelte-h="svelte-1q0z60y"></div>` : ``} <h3 class="my-5 text-md font-medium text-neutral-500" data-svelte-h="svelte-2d966z">Externe Ansprechpartner hinzufügen</h3> <form class="group flex w-full items-center justify-between space-x-3 rounded-full border border-neutral-300 p-2 text-left shadow-sm hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-coolGray-500 focus:ring-offset-2"><div class="flex min-w-0 flex-1 items-center space-x-3"><div class="min-w-0 flex-1 flex gap-3"><input class="border-0 rounded-md h-6 flex-1" placeholder="Name" type="text" required${add_attribute("value", unknownAssociate.name, 0)}> <input class="border-0 rounded-md h-6 flex-1" placeholder="Email" type="email" required${add_attribute("value", unknownAssociate.email, 0)}></div> <button type="submit" class="inline-flex h-10 17 flex-shrink-0 items-center justify-center text-neutral-600 pr-6" data-svelte-h="svelte-1hk42bb"> <svg class="h-5 w-5 text-coolGray-400 group-hover:text-neutral-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"></path></svg></button></div></form> `;
      }(__value);
    }(availableProjectLeaders())}`;
  } while (!$$settled);
  return $$rendered;
});
const WizardWorkentries = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let header = [
    {
      label: "Anzahl",
      property: "amount",
      component: NumberInput,
      class: "w-1/6",
      movable: false
    },
    {
      label: "Qualifikation",
      property: "qualificationId",
      component: Select_1,
      props: { options: [] },
      movable: false
    },
    {
      label: "Von",
      property: "startsAt",
      component: TimeInput,
      movable: false
    },
    {
      label: "Bis",
      property: "endsAt",
      component: TimeInput,
      movable: false
    }
  ];
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-oq2edb">Erforderliches Personal</h3> ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      { header, data: project.workEntries },
      {
        data: ($$value) => {
          project.workEntries = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div class="mt-5 grid justify-center"><button type="button" class="rounded-full border p-1 text-coolGray-500 hover:text-white shadow-sm hover:bg-coolGray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coolGray-600" data-svelte-h="svelte-12fyfha"><svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"></path></svg></button></div>`;
  } while (!$$settled);
  return $$rendered;
});
const WizardFinal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { project } = $$props;
  let { files = [] } = $$props;
  const handleFiles = async (ok, rejected) => {
    files = [...files, ...ok];
    if (rejected.length > 0) {
      alert("Datei hat falsches Format oder ist zu groß");
    }
  };
  if ($$props.project === void 0 && $$bindings.project && project !== void 0) $$bindings.project(project);
  if ($$props.files === void 0 && $$bindings.files && files !== void 0) $$bindings.files(files);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="space-y-12"><div class=""><h3 class="mt-7 leading-3 border-b border-neutral-300 pb-2" data-svelte-h="svelte-1o1e069">Optionale Angaben</h3> ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 mt-3" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-1iaxvai">Notiz / Hinweis</span> ${validate_component(Textarea, "Textarea").$$render(
          $$result,
          { value: project.notes },
          {
            value: ($$value) => {
              project.notes = $$value;
              $$settled = false;
            }
          },
          {}
        )}`;
      }
    })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 mt-3" }, {}, {
      default: () => {
        return `<span data-svelte-h="svelte-lbmoju">Dokumente</span>`;
      }
    })} ${files.length > 0 ? `<ul role="list" class="mt-5 divide-y divide-gray-100 rounded-md border border-gray-200">${each(files, (file) => {
      return `<li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6"><div class="flex w-0 flex-1 items-center"><svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd"></path></svg> <div class="ml-4 flex min-w-0 flex-1 gap-2"><span class="truncate font-medium">${escape(file.name)}</span> </div></div> <div class="ml-4 flex-shrink-0"><span class="flex-shrink-0 text-gray-400">${escape(fromBytes(file.size))}</span></div> <div class="ml-4 flex-shrink-0">${validate_component(RemoveButton, "RemoveButton").$$render(
        $$result,
        {
          value: file,
          onClick: (value2) => {
            files = files.filter((x) => x !== value2);
          }
        },
        {},
        {}
      )}</div> </li>`;
    })}</ul>` : ``} ${validate_component(FileDrop, "FileDrop").$$render($$result, { allowedSize: "4MB", extract: handleFiles }, {}, {})}</div></div>`;
  } while (!$$settled);
  return $$rendered;
});
const CustomerSelection = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_currentCustomer;
  $$unsubscribe_currentCustomer = subscribe(currentCustomer, (value2) => value2);
  let localCustomer = { registryName: "" };
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${localCustomer ? `<h3 class="text-2xl leading-7 text-neutral-600 mb-3 mt-4" data-svelte-h="svelte-fphzog">Kundenauswahl</h3> ${validate_component(AsyncTypeAhead, "AsyncTypeAhead").$$render(
      $$result,
      {
        label: "Projektkunde",
        call: searchCustomers,
        icon: "building-solid",
        displayProperty: "registryName",
        extract: (item) => {
        },
        value: localCustomer.registryName
      },
      {
        value: ($$value) => {
          localCustomer.registryName = $$value;
          $$settled = false;
        }
      },
      {
        default: ({ item }) => {
          return `<div><span class="font-medium pr-2">${escape(item.registry)}</span> <span>${escape(item.name)}</span></div>`;
        }
      }
    )}` : ``}`;
  } while (!$$settled);
  $$unsubscribe_currentCustomer();
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let steps;
  let $navigating, $$unsubscribe_navigating;
  let $currentCustomer, $$unsubscribe_currentCustomer;
  $$unsubscribe_navigating = subscribe(navigating, (value2) => $navigating = value2);
  $$unsubscribe_currentCustomer = subscribe(currentCustomer, (value2) => $currentCustomer = value2);
  let { data } = $$props;
  const now = /* @__PURE__ */ new Date();
  let project = {
    startsAt: now,
    endsAt: now,
    store: [
      { identityKey: "department", value: "" },
      { identityKey: "guests", value: 1 }
    ]
  };
  let files = [];
  currentProject.subscribe((val) => {
    if (val) {
      project = val;
    }
  });
  let openModal = false;
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    steps = [
      {
        label: "Allgemeine Informationen",
        route: "/create/project",
        state: data.step > 0 ? -1 : 0
      },
      {
        label: "Veranstaltungsort",
        route: "/create/project/venue",
        state: data.step > 1 ? -1 : data.step === 1 ? 0 : 1
      },
      {
        label: "Erforderliches Personal",
        route: "/create/project/work-entries",
        state: data.step > 2 ? -1 : data.step === 2 ? 0 : 1
      },
      {
        label: "Ansprechpartner",
        route: "/create/project/associated",
        state: data.step > 3 ? -1 : data.step === 3 ? 0 : 1
      },
      {
        label: "Weitere Informationen",
        route: "/create/project/additional",
        state: data.step > 4 ? -1 : data.step === 4 ? 0 : 1
      }
    ];
    $$rendered = `<div class="mt-1">${validate_component(Steps, "Steps").$$render($$result, { steps }, {}, {})} <div class="grid md:grid-cols-3 gap-5">${$navigating ? `<div class="text-center my-5">${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}</div>` : ``} <form class="bg-white mt-5 md:col-span-2 flex flex-col">${data.step === 0 && !$currentCustomer ? `${validate_component(CustomerSelection, "CustomerSelection").$$render($$result, {}, {}, {})}` : `${data.step === 0 && $currentCustomer ? `${validate_component(WizardGeneral, "WizardGeneral").$$render($$result, { project }, {}, {})}` : `${data.step === 1 ? `${validate_component(WizardVenue, "WizardVenue").$$render(
      $$result,
      { project },
      {
        project: ($$value) => {
          project = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : `${data.step === 2 ? `${validate_component(WizardWorkentries, "WizardWorkentries").$$render(
      $$result,
      { project },
      {
        project: ($$value) => {
          project = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : `${data.step === 3 ? `${validate_component(WizardAssociated, "WizardAssociated").$$render(
      $$result,
      { project },
      {
        project: ($$value) => {
          project = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : `${data.step === 4 ? `${validate_component(WizardAdditional, "WizardAdditional").$$render(
      $$result,
      { project },
      {
        project: ($$value) => {
          project = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(WizardFinal, "WizardFinal").$$render(
      $$result,
      { files, project },
      {
        files: ($$value) => {
          files = $$value;
          $$settled = false;
        },
        project: ($$value) => {
          project = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}`}`}`}`}`} <div class="flex mt-8 justify-between place-items-baseline flex-1">${`${validate_component(Button, "Button").$$render($$result, { color: "alternative", type: "button" }, {}, {
      default: () => {
        return `Zurück`;
      }
    })} ${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
      default: () => {
        return `${data.step < 4 ? `Weiter` : `Projekt Anfragen`}`;
      }
    })}`}</div></form> <div class="mt-5 ">${validate_component(ProjectOverview, "ProjectOverview").$$render($$result, { project }, {}, {})}</div></div></div> ${validate_component(Modal, "Modal").$$render(
      $$result,
      { open: openModal },
      {
        open: ($$value) => {
          openModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<flex class="flex flex-col gap-3 h-full"><div class=""><div class="text-center">${validate_component(CheckCircleOutline, "CheckCircleOutline").$$render(
            $$result,
            {
              class: "mx-auto mb-4 text-green-500 w-24 h-24 dark:text-gray-200"
            },
            {},
            {}
          )} <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400" data-svelte-h="svelte-bmp8zd">Möchten Sie ihre unverbindliche Anfrage stellen?</h3></div></div> <div class="grid grid-cols-2 gap-5">${validate_component(Button, "Button").$$render($$result, { color: "alternative", class: "mr-2" }, {}, {
            default: () => {
              return `Nein, Anfrage überarbeiten`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `Ja, abschicken`;
            }
          })}</div></flex>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_navigating();
  $$unsubscribe_currentCustomer();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
